/* eslint-disable @typescript-eslint/naming-convention */

export const DEFAULT_FIELDS = [
  {
    IsMandatory: false,
    Type: "string",
    Name: "prefix",
    Display: "Prefix",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "firstname",
    Display: "First Name",
    Rules: "",
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "MiddleName",
    Display: "Middle Name",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "lastname",
    Display: "Last Name",
    Rules: "",
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "suffix",
    Display: "Suffix",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "option",
    Name: "gender",
    Display: "Gender",
    Rules: null,
    Options: [
      {
        value: "M",
        text: "Male"
      },
      {
        value: "F",
        text: "Female"
      }
    ],
    Permission: "w",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "timezone",
    Display: "Time Zone",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "date",
    Name: "birthdate",
    Display: "Date of Birth",
    Rules: "callback_valid_date",
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "age",
    Display: "Age",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: null
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "address_type",
    Display: "Address Type",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "PostalCode",
    Display: "Postal Code",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "address1",
    Display: "Address Line1",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "address2",
    Display: "Address Line2",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "address_city",
    Display: "City",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "address_state",
    Display: "State",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "address_region",
    Display: "Region",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "address_country",
    Display: "Country",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "Addresses"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "phonenumber",
    Display: "Phone Number",
    Rules: "numeric|min_length[7]|max_length[15]",
    Options: null,
    Permission: "r",
    Parent: "PhoneNumbers"
  },
  {
    IsMandatory: false,
    Type: "string",
    Name: "phonetype",
    Display: "Phone Type",
    Rules: null,
    Options: null,
    Permission: "r",
    Parent: "PhoneNumbers"
  }
];

const stringSchema = {
  type: "Standard Fields",
  filterType: "string",
  aggregated: false
};

const selectSchema = {
  type: "Standard Fields",
  filterType: "select",
  aggregated: true
};

const textKeywordSchema = {
  type: "Standard Fields",
  filterType: "textKeyword",
  aggregated: false
};

const dateTimeSchema = {
  type: "Standard Fields",
  filterType: "datetime",
  aggregated: false
};

const checkboxSchema = {
  type: "Standard Fields",
  filterType: "checkbox",
  aggregated: false,
  values: [true, false]
};

const textSchema = {
  type: "Standard Fields",
  filterType: "text",
  aggregated: false
};

const rangeSchema = {
  type: "Standard Fields",
  filterType: "range",
  aggregated: false
};
const booleanSchema = {
  type: "Standard Fields",
  filterType: "boolean",
  aggregated: false
};

export const availableFilters = [
  {
    name: "Uid",
    displayName: "Uid",
    ...stringSchema
  },
  {
    name: "ID",
    displayName: "ID",
    ...stringSchema
  },
  {
    name: "Provider",
    displayName: "Provider",
    ...selectSchema
  },
  {
    name: "Prefix",
    displayName: "Prefix",
    ...selectSchema
  },
  {
    name: "FirstName",
    displayName: "First Name",
    ...textKeywordSchema
  },
  {
    name: "MiddleName",
    displayName: "Middle Name",
    ...textKeywordSchema
  },
  {
    name: "LastName",
    displayName: "Last Name",
    ...textKeywordSchema
  },
  {
    name: "FullName",
    displayName: "Full Name",
    ...textKeywordSchema
  },
  {
    name: "NickName",
    displayName: "Nick Name",
    ...textKeywordSchema
  },
  {
    name: "ProfileName",
    displayName: "Profile Name",
    ...textKeywordSchema
  },
  {
    name: "Suffix",
    displayName: "Suffix",
    ...selectSchema
  },
  {
    type: "Standard Fields",
    name: "BirthDate",
    displayName: "Birth Date",
    filterType: "date"
  },
  {
    type: "Standard Fields",
    name: "Gender",
    displayName: "Gender",
    filterType: "select",
    values: [
      { name: "Male", displayName: "Male" },
      { name: "Female", displayName: "Female" },
      { name: "Unknown", displayName: "Unknown" }
    ]
  },
  {
    name: "Website",
    displayName: "Website",
    ...textSchema
  },
  {
    name: "Email.Type",
    displayName: "Email.Type",
    ...selectSchema
  },
  {
    name: "Email.Value",
    displayName: "Email.Value",
    ...textKeywordSchema
  },
  {
    name: "IdentityVerification.Provider",
    displayName: "IdentityVerification.Provider",
    ...textKeywordSchema
  },
  {
    name: "IdentityVerification.Transactions.WorkflowID",
    displayName: "IdentityVerification.Transactions.WorkflowID",
    ...textKeywordSchema
  },
  {
    name: "IdentityVerification.Transactions.Status",
    displayName: "IdentityVerification.Transactions.Status",
    ...textKeywordSchema
  },
  {
    name: "IdentityVerification.Transactions.VerificationDate",
    displayName: "IdentityVerification.Transactions.VerificationDate",
    ...textKeywordSchema
  },
  {
    name: "Country.Code",
    displayName: "Country.Code",
    ...selectSchema
  },
  {
    name: "Country.Name",
    displayName: "Country.Name",
    ...selectSchema
  },
  {
    name: "HomeTown",
    displayName: "Home Town",
    ...textKeywordSchema
  },
  {
    name: "State",
    displayName: "State",
    ...selectSchema
  },
  {
    name: "City",
    displayName: "City",
    ...selectSchema
  },
  {
    name: "Industry",
    displayName: "Industry",
    ...selectSchema
  },
  {
    name: "About",
    displayName: "About",
    ...textSchema
  },
  {
    name: "TimeZone",
    displayName: "Time Zone",
    ...selectSchema
  },
  {
    name: "LocalLanguage",
    displayName: "Local Language",
    ...selectSchema
  },
  {
    name: "TagLine",
    displayName: "Tag Line",
    ...textSchema
  },
  {
    name: "Language",
    displayName: "Language",
    ...selectSchema
  },
  {
    name: "Verified",
    displayName: "Verified",
    ...selectSchema
  },
  {
    name: "MainAddress",
    displayName: "Main Address",
    ...textSchema
  },
  {
    name: "CreatedDate",
    displayName: "Created Date",
    ...dateTimeSchema
  },
  {
    name: "ModifiedDate",
    displayName: "Modified Date",
    ...dateTimeSchema
  },
  {
    name: "LocalCity",
    displayName: "Local City",
    ...selectSchema
  },
  {
    name: "LocalCountry",
    displayName: "Local Country",
    ...selectSchema
  },
  {
    name: "ProfileCountry",
    displayName: "Profile Country",
    ...selectSchema
  },
  {
    name: "FirstLogin",
    displayName: "First Login",
    ...checkboxSchema
  },
  {
    name: "IsProtected",
    displayName: "Is Protected",
    ...checkboxSchema
  },
  {
    name: "RelationshipStatus",
    displayName: "Relationship Status",
    ...selectSchema
  },
  {
    name: "Quota",
    displayName: "Quota",
    ...textSchema
  },
  {
    name: "InterestedIn",
    displayName: "Interested In",
    ...stringSchema
  },
  {
    name: "Religion",
    displayName: "Religion",
    ...textSchema
  },
  {
    name: "Political",
    displayName: "Political",
    ...textSchema
  },
  {
    name: "FollowersCount",
    displayName: "Followers Count",
    ...rangeSchema
  },
  {
    name: "FriendsCount",
    displayName: "Friends Count",
    ...rangeSchema
  },
  {
    name: "IsGeoEnabled",
    displayName: "Is Geo Enabled",
    ...selectSchema
  },
  {
    name: "TotalStatusesCount",
    displayName: "Total Statuses Count",
    ...rangeSchema
  },
  {
    name: "Associations",
    displayName: "Associations",
    ...textSchema
  },
  {
    name: "NumRecommenders",
    displayName: "Num Recommenders",
    ...rangeSchema
  },
  {
    name: "Honors",
    displayName: "Honors",
    ...textSchema
  },
  {
    name: "AgeRange.Min",
    displayName: "AgeRange.Min",
    ...rangeSchema
  },
  {
    name: "AgeRange.Max",
    displayName: "AgeRange.Max",
    ...rangeSchema
  },
  {
    name: "Hireable",
    displayName: "Hireable",
    ...checkboxSchema
  },
  {
    name: "Age",
    displayName: "Age",
    ...rangeSchema
  },
  {
    name: "ProfessionalHeadline",
    displayName: "Professional Headline",
    ...textSchema
  },
  {
    name: "KloutScore.KloutId",
    displayName: "KloutScore.KloutId",
    ...stringSchema
  },
  {
    name: "KloutScore.Score",
    displayName: "KloutScore.Score",
    ...rangeSchema
  },
  {
    name: "LRUserID",
    displayName: "LR User ID",
    ...stringSchema
  },
  {
    name: "TotalPrivateRepository",
    displayName: "Total Private Repository",
    ...rangeSchema
  },
  {
    name: "Currency",
    displayName: "Currency",
    ...selectSchema
  },
  {
    name: "PublicGists",
    displayName: "Public Gists",
    ...rangeSchema
  },
  {
    name: "PrivateGists",
    displayName: "Private Gists",
    ...rangeSchema
  },
  {
    name: "Company",
    displayName: "Company",
    ...textKeywordSchema
  },
  {
    name: "PinsCount",
    displayName: "Pins Count",
    ...rangeSchema
  },
  {
    name: "BoardsCount",
    displayName: "Boards Count",
    ...rangeSchema
  },
  {
    name: "LikesCount",
    displayName: "Likes Count",
    ...rangeSchema
  },
  {
    name: "SignupDate",
    displayName: "Signup Date",
    ...dateTimeSchema
  },
  {
    name: "LastLoginDate",
    displayName: "Last Login Date",
    ...dateTimeSchema
  },
  {
    name: "LastPasswordChangeDate",
    displayName: "Last Password Change Date",
    ...dateTimeSchema
  },
  {
    name: "PasswordExpirationDate",
    displayName: "Password Expiration Date",
    ...dateTimeSchema
  },
  {
    name: "EmailVerified",
    displayName: "Email Verified",
    ...checkboxSchema
  },
  {
    name: "IsActive",
    displayName: "Is Active",
    ...checkboxSchema
  },
  {
    name: "IsDeleted",
    displayName: "Is Blocked",
    ...checkboxSchema
  },
  {
    name: "IsEmailSubscribed",
    displayName: "Is Email Subscribed",
    ...checkboxSchema
  },
  {
    name: "UserName",
    displayName: "User Name",
    ...stringSchema
  },
  {
    name: "NoOfLogins",
    displayName: "No Of Logins",
    ...rangeSchema
  },
  {
    name: "PreviousUids",
    displayName: "Previous Uids",
    ...stringSchema
  },
  {
    name: "PhoneId",
    displayName: "Phone Id",
    ...stringSchema
  },
  {
    name: "PhoneIdVerified",
    displayName: "Phone ID Verified",
    ...checkboxSchema
  },
  {
    name: "Roles",
    displayName: "Roles",
    ...stringSchema
  },
  {
    name: "ExternalUserLoginId",
    displayName: "External User LoginId",
    ...stringSchema
  },
  {
    name: "ExternalIds.Source",
    displayName: "ExternalIds.Source",
    ...selectSchema
  },
  {
    name: "ExternalIds.SourceId",
    displayName: "ExternalIds.SourceId",
    ...stringSchema
  },
  {
    name: "FailedLoginAttempt",
    displayName: "Failed Login Attempt",
    ...rangeSchema
  },
  {
    name: "SecurityQuestionFailedResetPasswordAttempts",
    displayName: "Security Question Failed Reset Password Attempts",
    ...rangeSchema
  },
  {
    name: "DisableLogin",
    displayName: "Disable Login",
    ...checkboxSchema
  },
  {
    name: "RegistrationProvider",
    displayName: "Registration Provider",
    ...stringSchema
  },
  {
    name: "IsLoginLocked",
    displayName: "Is Login Locked",
    ...checkboxSchema
  },
  {
    name: "LastLoginLocation",
    displayName: "Last Login Location",
    ...textKeywordSchema
  },
  {
    name: "RegistrationSource",
    displayName: "Registration Source",
    ...stringSchema
  },
  {
    name: "IsCustomUid",
    displayName: "Is Custom Uid",
    ...checkboxSchema
  },
  {
    name: "UnverifiedEmail.Type",
    displayName: "UnverifiedEmail.Type",
    ...selectSchema
  },
  {
    name: "UnverifiedEmail.Value",
    displayName: "UnverifiedEmail.Value",
    ...textKeywordSchema
  },
  {
    name: "SignupLog.UserAgent",
    displayName: "SignupLog.UserAgent",
    ...textSchema
  },
  {
    name: "SignupLog.IP",
    displayName: "SignupLog.IP",
    ...stringSchema
  },
  {
    name: "SignupLog.Host",
    displayName: "SignupLog.Host",
    ...textKeywordSchema
  },
  {
    name: "PhoneNumbers.PhoneType",
    displayName: "PhoneNumbers.PhoneType",
    ...selectSchema
  },
  {
    name: "PhoneNumbers.PhoneNumber",
    displayName: "PhoneNumbers.PhoneNumber",
    ...stringSchema
  },
  {
    name: "IMAccounts.AccountType",
    displayName: "IMAccounts.AccountType",
    ...selectSchema
  },
  {
    name: "IMAccounts.AccountName",
    displayName: "IMAccounts.AccountName",
    ...textKeywordSchema
  },
  {
    name: "Addresses.Type",
    displayName: "Addresses.Type",
    ...selectSchema
  },
  {
    name: "Addresses.Address1",
    displayName: "Addresses.Address1",
    ...textSchema
  },
  {
    name: "Addresses.Address2",
    displayName: "Addresses.Address2",
    ...textSchema
  },
  {
    type: "Standard Fields",
    name: "Addresses.City",
    displayName: "Addresses.City",
    filterType: "textKeyword",
    aggregated: false
  },
  {
    name: "Addresses.State",
    displayName: "Addresses.State",
    ...textKeywordSchema
  },
  {
    name: "Addresses.PostalCode",
    displayName: "Addresses.PostalCode",
    ...selectSchema
  },
  {
    name: "Addresses.Region",
    displayName: "Addresses.Region",
    ...textKeywordSchema
  },
  {
    name: "Addresses.Country",
    displayName: "Addresses.Country",
    ...selectSchema
  },
  {
    name: "Languages._id",
    displayName: "Languages.Id",
    ...selectSchema
  },
  {
    name: "Languages.Name",
    displayName: "Languages.Name",
    ...selectSchema
  },
  {
    name: "Languages.Proficiency",
    displayName: "Languages.Proficiency",
    ...selectSchema
  }
];
export const availableIOFilters = [
  {
    name: "PIN.PIN",
    displayName: "PIN.PIN",
    ...booleanSchema
  },
  {
    name: "Sessions.Count",
    displayName: "Active Session Count",
    ...rangeSchema
  }
];

export const customObjAvailableFilter = [
  {
    name: "Uid",
    displayName: "Uid",
    ...stringSchema
  },
  {
    name: "IsActive",
    displayName: "Is Active",
    ...checkboxSchema
  },
  {
    name: "IsDeleted",
    displayName: "Is Deleted",
    ...checkboxSchema
  },
  {
    name: "DateCreated",
    displayName: "Date Created",
    ...dateTimeSchema
  },
  {
    name: "DateModified",
    displayName: "Date Modified",
    ...dateTimeSchema
  }
];

export const esPrimaryTypesTranslation = {
  string: "keyword",
  integer: "integer",
  long: "long",
  short: "short",
  float: "float",
  double: "double",
  text: "text",
  boolean: "boolean",
  date: "date"
};

export const localPrimaryTypesTranslation = {
  keyword: "string",
  integer: "range",
  long: "range",
  short: "range",
  float: "range",
  double: "range",
  text: "text",
  boolean: "checkbox",
  date: "date"
};

export const FilterOps = {
  string: {
    Equals: "=",
    "Not Equals": "!=",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS"
  },
  textKeyword: {
    // eslint-disable-line
    Equals: "=",
    "Not Equals": "!=",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS",
    Contains: "Contains",
    "Not Contains": "Not_Contains"
  },
  select: {
    Equals: "=",
    "Not Equals": "!=",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS"
  },
  mandatorySelect: {
    Equals: "=",
    "Not Equals": "!="
  },
  selectEquals: {
    Equals: "="
  },
  checkbox: {
    Equals: "=",
    "Not Equals": "!=",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS"
  },
  range: {
    Equals: "=",
    Modulo: "MODULO",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS",
    Between: "BETWEEN",
    "Greater Than": ">",
    "Greater Than or Equal": ">=",
    "Less Than": "<",
    "Less Than or Equal": "<="
  },
  date: {
    Equals: "=",
    Between: "BETWEEN",
    "Greater Than": ">",
    "Greater Than or Equal": ">=",
    "Less Than": "<",
    "Less Than or Equal": "<=",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS"
  },
  datetime: {
    Equals: "=",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS",
    Between: "BETWEEN",
    "Greater Than": ">",
    "Greater Than or Equal": ">=",
    "Less Than": "<",
    "Less Than or Equal": "<="
  },
  text: {
    Contains: "Contains",
    "Not Contains": "Not_Contains",
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS"
  },
  boolean: {
    Exists: "EXISTS",
    "Not Exists": "NOT_EXISTS"
  },
  mandatoryCheckBox: {
    Equals: "=",
    "Not Equals": "!="
  },
  mandatoryTextKeyWord: {
    Equals: "=",
    "Not Equals": "!=",
    Contains: "LIKE"
  },
  mandatoryRange: {
    Equals: "=",
    "Not Equals": "!=",
    Modulo: "MODULO",
    Between: "BETWEEN",
    "Greater Than": ">",
    "Greater Than or Equal": ">=",
    "Less Than": "<",
    "Less Than or Equal": "<="
  }
};

export const API_ANALYTICS_INTERVALS = [
  {
    text: "Last 15 minutes",
    value: "15"
  },
  {
    text: "Last 30 minutes",
    value: "30"
  },
  {
    text: "Last 1 hour",
    value: "60"
  },
  {
    text: "Last 3 hours",
    value: (60 * 3).toString()
  },
  {
    text: "Last 6 hours",
    value: (60 * 6).toString()
  },
  {
    text: "Last 12 hours",
    value: (60 * 12).toString()
  },
  {
    text: "Last 1 day",
    value: (60 * 24).toString()
  },
  {
    text: "Last 3 days",
    value: (60 * 24 * 3).toString()
  },
  {
    text: "Last 7 days",
    value: (60 * 24 * 7).toString()
  },
  {
    text: "Last 15 days",
    value: (60 * 24 * 15).toString()
  },
  {
    text: "Last 30 days",
    value: (60 * 24 * 30).toString()
  }
];

export const COMMUNICATION_ANALYTICS_INTERVALS = [
  {
    text: "Last 15 minutes",
    value: "15"
  },
  {
    text: "Last 1 hour",
    value: "60"
  },
  {
    text: "Last 1 day",
    value: (60 * 24).toString()
  }
];

/**
 * Following are the acceptable types: string, datetime, boolean, object, table, link, stringArray
 */

export const UserProfileSections = {
  Security: {
    LastPasswordChangeDate: "datetime",
    PasswordExpirationDate: "datetime",
    LastPasswordChangeToken: "string",
    IsDeleted: "boolean",
    IsLoginLocked: "boolean",
    DisableLogin: "boolean",
    FailedLoginAttempt: "string",
    PrivacyPolicyHistory: "object",
    SecurityQuestionFailedResetPasswordAttempts: "string"
  },
  Insights: {
    CreatedDate: "datetime",
    SignupDate: "datetime",
    RegistrationSource: "string",
    SignupLog: "object",
    UserAgent: "object"
  },
  Activity: {
    IsActive: "boolean",
    LastLoginDate: "datetime",
    LastLoginLocation: "string",
    NoOfLogins: "string",
    ModifiedDate: "datetime"
  },
  Social: {
    ID: "string",
    FullName: "string",
    Email: "table",
    PhoneNumbers: "object",
    About: "string",
    AgeRange: "object",
    Associations: "string",
    Awards: "table",
    Badges: "table",
    BoardsCount: "string",
    Books: "table",
    Certifications: "table",
    City: "string",
    Company: "string",
    Country: "object",
    Courses: "table",
    CoverPhoto: "link",
    Currency: "string",
    CurrentStatus: "table",
    ExternalUserLoginId: "string",
    Family: "table",
    Favicon: "string",
    FavoriteThings: "table",
    FirstLogin: "boolean",
    FollowersCount: "string",
    FriendsCount: "string",
    Games: "table",
    GistsUrl: "link",
    GravatarImageUrl: "link",
    Hireable: "boolean",
    HomeTown: "string",
    Honors: "string",
    HttpsImageUrl: "link",
    ImageUrl: "link",
    Industry: "string",
    InspirationalPeople: "table",
    InterestedIn: "stringArray",
    IsEmailSubscribed: "boolean",
    IsGeoEnabled: "boolean",
    IsProtected: "boolean",
    IsRequiredFieldsFilledOnce: "boolean",
    IsSecurePassword: "string",
    JobBookmarks: "table",
    KloutScore: "object",
    LRUserID: "string",
    Languages: "table",
    LikesCount: "string",
    LocalCity: "string",
    LocalCountry: "string",
    LocalLanguage: "string",
    MainAddress: "string",
    MemberUrlResources: "table",
    Movies: "table",
    MutualFriends: "table",
    NickName: "string",
    NumRecommenders: "string",
    Patents: "table",
    PinsCount: "string",
    PlacesLived: "table",
    Political: "string",
    PreviousUids: "string",
    PrivateGists: "string",
    ProfessionalHeadline: "string",
    ProfileCity: "string",
    ProfileCountry: "string",
    ProfileImageUrls: "object",
    ProfileModifiedDate: "datetime",
    ProfileName: "string",
    ProfileUrl: "link",
    Projects: "table",
    PublicGists: "string",
    PublicRepository: "string",
    Publications: "table",
    Quota: "string",
    RecommendationsReceived: "table",
    RegistrationProvider: "string",
    RelatedProfileViews: "table",
    RelationshipStatus: "string",
    Religion: "string",
    RepositoryUrl: "link",
    StarredUrl: "link",
    State: "string",
    Subscription: "object",
    Suggestions: "object",
    TagLine: "string",
    TeleVisionShow: "table",
    ThumbnailImageUrl: "link",
    TotalPrivateRepository: "string",
    TotalStatusesCount: "string",
    UnverifiedEmail: "object",
    UserName: "string",
    Verified: "boolean",
    Volunteer: "table",
    WebProfiles: "object",
    Website: "link"
  }
};

export const validationRules = {
  alpha: /^[a-z]+$/i,
  alpha_dash: /^[a-z0-9_-]+$/i,
  alpha_numeric: /^[a-z0-9]+$/i,
  alpha_numeric_space: /^[a-z0-9 ]+$/i,
  decimal: /^-?[0-9]*.?[0-9]+$/,
  exact_length: "No regex usage: exact_length[integer]",
  greater_than: "No regex usage: greater_than[integer]",
  integer: /^-?[0-9]+$/,
  is_natural: /^[0-9]+$/i,
  is_natural_no_zero: /^[1-9][0-9]*$/i,
  valid_email: /\S+@\S+\.\S+/
};

export const MAX_RENDER_QUESTION_COUNT = 10;

export const EMAIL_TEMPLATE_MAX_LIMITS = {
  NOTIFICATION_COUNT: 10000,
  NOTIFICATION_FREQUENCY: 43200,
  LINK_EXPIRE: 129600
};

export const SMS_TEMPLATE_MAX_LIMITS = {
  NOTIFICATION_COUNT: 5000,
  NOTIFICATION_FREQUENCY: 43200,
  OTP_EXPIRE: 2592000
};

export interface FullUserProfileDataPointsSchema {
  name: string;
  type: string;
  featured?: boolean;
  children?: {
    name: string;
    type: string;
    children?: {
      name: string;
      type: string;
      children?: {
        name: string;
        type: string;
      }[];
    }[];
  }[];
}

export const FullUserProfileDataPoints: FullUserProfileDataPointsSchema[] = [
  {
    name: "Uid",
    type: "string"
  },
  {
    name: "Prefix",
    type: "string"
  },
  {
    name: "Suffix",
    type: "string"
  },
  {
    name: "FirstName",
    type: "string",
    featured: true
  },
  {
    name: "MiddleName",
    type: "string",
    featured: true
  },
  {
    name: "LastName",
    type: "string",
    featured: true
  },
  {
    name: "NickName",
    type: "string"
  },
  {
    name: "ProfileName",
    type: "string"
  },
  {
    name: "BirthDate",
    type: "string",
    featured: true
  },
  {
    name: "Gender",
    type: "string",
    featured: true
  },
  {
    name: "Website",
    type: "string"
  },
  {
    name: "Email",
    type: "objects",
    children: [
      {
        name: "Type",
        type: "string"
      },
      {
        name: "Value",
        type: "string"
      }
    ],
    featured: true
  },
  {
    name: "Country",
    type: "object",
    children: [
      {
        name: "Code",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      }
    ]
  },
  {
    name: "ThumbnailImageUrl",
    type: "string"
  },
  {
    name: "ImageUrl",
    type: "string"
  },
  {
    name: "Favicon",
    type: "string"
  },
  {
    name: "ProfileUrl",
    type: "string"
  },
  {
    name: "HomeTown",
    type: "string"
  },
  {
    name: "State",
    type: "string",
    featured: true
  },
  {
    name: "City",
    type: "string",
    featured: true
  },
  {
    name: "Industry",
    type: "string"
  },
  {
    name: "About",
    type: "string"
  },
  {
    name: "TimeZone",
    type: "string"
  },
  {
    name: "LocalLanguage",
    type: "string"
  },
  {
    name: "CoverPhoto",
    type: "string"
  },
  {
    name: "TagLine",
    type: "string"
  },
  {
    name: "Positions",
    type: "objects",
    children: [
      {
        name: "Position",
        type: "string"
      },
      {
        name: "Summary",
        type: "string"
      },
      {
        name: "StartDate",
        type: "string"
      },
      {
        name: "EndDate",
        type: "string"
      },
      {
        name: "IsCurrent",
        type: "string"
      },
      {
        name: "Company",
        type: "object",
        children: [
          {
            name: "Name",
            type: "string"
          },
          {
            name: "Type",
            type: "string"
          },
          {
            name: "Industry",
            type: "string"
          }
        ]
      },
      {
        name: "Location",
        type: "string"
      }
    ]
  },
  {
    name: "Educations",
    type: "objects",
    children: [
      {
        name: "School",
        type: "string"
      },
      {
        name: "year",
        type: "string"
      },
      {
        name: "type",
        type: "string"
      },
      {
        name: "notes",
        type: "string"
      },
      {
        name: "activities",
        type: "string"
      },
      {
        name: "degree",
        type: "string"
      },
      {
        name: "fieldofstudy",
        type: "string"
      },
      {
        name: "StartDate",
        type: "string"
      },
      {
        name: "EndDate",
        type: "string"
      }
    ]
  },
  {
    name: "PhoneNumbers",
    type: "objects",
    featured: true,
    children: [
      {
        name: "PhoneType",
        type: "string"
      },
      {
        name: "PhoneNumber",
        type: "string"
      }
    ]
  },
  {
    name: "IMAccounts",
    type: "objects",
    children: [
      {
        name: "AccountType",
        type: "string"
      },
      {
        name: "AccountName",
        type: "string"
      }
    ]
  },
  {
    name: "Addresses",
    type: "objects",
    featured: true,
    children: [
      {
        name: "Type",
        type: "string"
      },
      {
        name: "Address1",
        type: "string"
      },
      {
        name: "Address2",
        type: "string"
      },
      {
        name: "City",
        type: "string"
      },
      {
        name: "State",
        type: "string"
      },
      {
        name: "PostalCode",
        type: "string"
      },
      {
        name: "Region",
        type: "string"
      },
      {
        name: "Country",
        type: "string"
      }
    ]
  },
  {
    name: "MainAddress",
    type: "string"
  },
  {
    name: "LocalCity",
    type: "string"
  },
  {
    name: "ProfileCity",
    type: "string"
  },
  {
    name: "LocalCountry",
    type: "string"
  },
  {
    name: "ProfileCountry",
    type: "string"
  },
  {
    name: "FirstLogin",
    type: "string"
  },
  {
    name: "IsProtected",
    type: "boolean"
  },
  {
    name: "RelationshipStatus",
    type: "string"
  },
  {
    name: "Quote",
    type: "string"
  },
  {
    name: "InterestedIn",
    type: "stringArray"
  },
  {
    name: "Interests",
    type: "objects",
    children: [
      {
        name: "InterestedType",
        type: "string"
      },
      {
        name: "InterestedName",
        type: "string"
      }
    ]
  },
  {
    name: "Religion",
    type: "string"
  },
  {
    name: "Political",
    type: "string"
  },
  {
    name: "Sports",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      }
    ]
  },
  {
    name: "InspirationalPeople",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      }
    ]
  },
  {
    name: "HttpsImageUrl",
    type: "string"
  },
  {
    name: "FollowersCount",
    type: "number"
  },
  {
    name: "FriendsCount",
    type: "number"
  },
  {
    name: "IsGeoEnabled",
    type: "string"
  },
  {
    name: "TotalStatusesCount",
    type: "number"
  },
  {
    name: "Associations",
    type: "string"
  },
  {
    name: "NumRecommenders",
    type: "number"
  },
  {
    name: "Honors",
    type: "string"
  },
  {
    name: "Awards",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Issuer",
        type: "string"
      }
    ]
  },
  {
    name: "Skills",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      }
    ]
  },
  {
    name: "CurrentStatus",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Text",
        type: "string"
      },
      {
        name: "Source",
        type: "string"
      },
      {
        name: "CreatedDate",
        type: "string"
      }
    ]
  },
  {
    name: "Certifications",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Authority",
        type: "string"
      },
      {
        name: "Number",
        type: "string"
      },
      {
        name: "StartDate",
        type: "string"
      },
      {
        name: "EndDate",
        type: "string"
      }
    ]
  },
  {
    name: "Courses",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Number",
        type: "string"
      }
    ]
  },
  {
    name: "Volunteer",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Role",
        type: "string"
      },
      {
        name: "Organization",
        type: "string"
      },
      {
        name: "Cause",
        type: "string"
      }
    ]
  },
  {
    name: "RecommendationsReceived",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "RecommendationType",
        type: "string"
      },
      {
        name: "RecommendationText",
        type: "string"
      },
      {
        name: "Recommender",
        type: "string"
      }
    ]
  },
  {
    name: "Languages",
    type: "objects",
    featured: true,

    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Proficiency",
        type: "string"
      }
    ]
  },
  {
    name: "Projects",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Summary",
        type: "string"
      },
      {
        name: "With",
        type: "objects",
        children: [
          {
            name: "Id",
            type: "string"
          },
          {
            name: "Name",
            type: "string"
          }
        ]
      },
      {
        name: "StartDate",
        type: "string"
      },
      {
        name: "EndDate",
        type: "string"
      },
      {
        name: "IsCurrent",
        type: "string"
      }
    ]
  },
  {
    name: "Games",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Category",
        type: "string"
      },
      {
        name: "CreatedDate",
        type: "string"
      }
    ]
  },
  {
    name: "Family",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Relationship",
        type: "string"
      }
    ]
  },
  {
    name: "TeleVisionShow",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Category",
        type: "string"
      },
      {
        name: "CreatedDate",
        type: "string"
      }
    ]
  },
  {
    name: "MutualFriends",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "FirstName",
        type: "string"
      },
      {
        name: "LastName",
        type: "string"
      },
      {
        name: "Birthday",
        type: "string"
      },
      {
        name: "Hometown",
        type: "string"
      },
      {
        name: "Link",
        type: "string"
      },
      {
        name: "Gender",
        type: "string"
      }
    ]
  },
  {
    name: "Movies",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Category",
        type: "string"
      },
      {
        name: "CreatedDate",
        type: "string"
      }
    ]
  },
  {
    name: "Books",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Category",
        type: "string"
      },
      {
        name: "CreatedDate",
        type: "string"
      }
    ]
  },
  {
    name: "AgeRange",
    type: "object",
    children: [
      {
        name: "Min",
        type: "number"
      },
      {
        name: "Max",
        type: "number"
      }
    ]
  },
  {
    name: "PublicRepository",
    type: "string"
  },
  {
    name: "Hireable",
    type: "string"
  },
  {
    name: "RepositoryUrl",
    type: "string"
  },
  {
    name: "Patents",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Title",
        type: "string"
      },
      {
        name: "Date",
        type: "string"
      }
    ]
  },
  {
    name: "FavoriteThings",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Type",
        type: "string"
      }
    ]
  },
  {
    name: "ProfessionalHeadline",
    type: "string"
  },
  {
    name: "ProviderAccessCredential",
    type: "object",
    children: [
      {
        name: "AccessToken",
        type: "string"
      },
      {
        name: "TokenSecret",
        type: "string"
      }
    ]
  },
  {
    name: "RelatedProfileViews",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "FirstName",
        type: "string"
      },
      {
        name: "LastName",
        type: "string"
      }
    ]
  },
  {
    name: "KloutScore",
    type: "object",
    children: [
      {
        name: "KloutId",
        type: "string"
      },
      {
        name: "Score",
        type: "number"
      }
    ]
  },
  {
    name: "LRUserID",
    type: "string"
  },
  {
    name: "PlacesLived",
    type: "objects",
    children: [
      {
        name: "Name",
        type: "string"
      },
      {
        name: "IsPrimary",
        type: "boolean"
      }
    ]
  },
  {
    name: "Publications",
    type: "objects",
    children: [
      {
        name: "Id",
        type: "string"
      },
      {
        name: "Title",
        type: "string"
      },
      {
        name: "Publisher",
        type: "string"
      },
      {
        name: "Authors",
        type: "objects",
        children: [
          {
            name: "Id",
            type: "string"
          },
          {
            name: "Name",
            type: "string"
          }
        ]
      },
      {
        name: "Date",
        type: "string"
      },
      {
        name: "Url",
        type: "string"
      },
      {
        name: "Summary",
        type: "string"
      }
    ]
  },
  {
    name: "JobBookmarks",
    type: "objects",
    children: [
      {
        name: "IsApplied",
        type: "boolean"
      },
      {
        name: "ApplyTimestamp",
        type: "string"
      },
      {
        name: "IsSaved",
        type: "boolean"
      },
      {
        name: "SavedTimestamp",
        type: "string"
      },
      {
        name: "Job",
        type: "object",
        children: [
          {
            name: "Active",
            type: "boolean"
          },
          {
            name: "Id",
            type: "string"
          },
          {
            name: "DescriptionSnippet",
            type: "string"
          },
          {
            name: "Compony",
            type: "object",
            children: [
              {
                name: "Id",
                type: "string"
              },
              {
                name: "Name",
                type: "string"
              }
            ]
          },
          {
            name: "Position",
            type: "object",
            children: [
              {
                name: "Title",
                type: "string"
              }
            ]
          },
          {
            name: "PostingTimestamp",
            type: "string"
          }
        ]
      }
    ]
  },
  {
    name: "Suggestions",
    type: "object",
    children: [
      {
        name: "CompaniestoFollow",
        type: "objects",
        children: [
          {
            name: "Id",
            type: "string"
          },
          {
            name: "Name",
            type: "string"
          }
        ]
      },
      {
        name: "IndustriestoFollow",
        type: "objects",
        children: [
          {
            name: "Id",
            type: "string"
          },
          {
            name: "Name",
            type: "string"
          }
        ]
      },
      {
        name: "NewssourcetoFollow",
        type: "objects",
        children: [
          {
            name: "Id",
            type: "string"
          },
          {
            name: "Name",
            type: "string"
          }
        ]
      },
      {
        name: "PeopletoFollow",
        type: "objects",
        children: [
          {
            name: "Id",
            type: "string"
          },
          {
            name: "Name",
            type: "string"
          }
        ]
      }
    ]
  },
  {
    name: "Badges",
    type: "objects",
    children: [
      {
        name: "BadgeId",
        type: "string"
      },
      {
        name: "Name",
        type: "string"
      },
      {
        name: "BadgeMessage",
        type: "string"
      },
      {
        name: "Description",
        type: "string"
      },
      {
        name: "ImageUrl",
        type: "string"
      }
    ]
  },
  {
    name: "MemberUrlResources",
    type: "objects",
    children: [
      {
        name: "Url",
        type: "string"
      },
      {
        name: "UrlName",
        type: "string"
      }
    ]
  },
  {
    name: "TotalPrivateRepository",
    type: "number"
  },
  {
    name: "Currency",
    type: "string"
  },
  {
    name: "StarredUrl",
    type: "string"
  },
  {
    name: "GistsUrl",
    type: "string"
  },
  {
    name: "PublicGists",
    type: "number"
  },
  {
    name: "PrivateGists",
    type: "number"
  },
  {
    name: "Subscription",
    type: "object",
    children: [
      {
        name: "Name",
        type: "string"
      },
      {
        name: "Space",
        type: "string"
      },
      {
        name: "PrivateRepos",
        type: "string"
      },
      {
        name: "Collaborators",
        type: "string"
      }
    ]
  },
  {
    name: "Company",
    type: "string"
  },
  {
    name: "GravatarImageUrl",
    type: "string"
  },
  {
    name: "EmailVerified",
    type: "boolean"
  },
  {
    name: "IsActive",
    type: "boolean"
  },
  {
    name: "IsDeleted",
    type: "boolean"
  },
  {
    name: "IsEmailSubscribed",
    type: "boolean"
  },
  {
    name: "UserName",
    type: "string",
    featured: true
  },
  {
    name: "PhoneId",
    type: "string"
  },
  {
    name: "PhoneIdVerified",
    type: "boolean"
  }
];

export const staticData = {
  Pages: [
    {
      PageType: "Auth",
      CustomCss: ["/css/hosted-auth-default.css"],
      HeadTags: [],
      FavIcon: "/images/favicon.ico",
      HtmlBody:
        "<div class='grid lr-hostr-container'>\n<div id='lr-raas-message' class='loginradius-raas-success-message'></div>\n<div class='grid lr-hostr-frame cf'>\n<div id='lr-social-login' class='lr-social-login-frame lr-frames lr-sample-background-enabled cf'>\n<h2 class='lr-social-login-message'>Login with your social account</h2>\n<div id='interfacecontainerdiv' class='lr-sl-shaded-brick-frame cf lr-widget-container'>\n</div>\n<script type=\"text/html\" id=\"loginradiuscustom_tmpl\"><span class=\"lr-provider-label lr-sl-shaded-brick-button lr-flat-<#=Name.toLowerCase()#>\" onclick=\" return LRObject.util.openWindow('<#= Endpoint #>'); \" title=\"Sign up with <#= Name #>\" alt=\"Sign in with <#= Name#>\"><span class=\"lr-sl-icon lr-sl-icon-<#= Name.toLowerCase()#>\"></span>Login with <#= Name#> </span> </script></div>\n<div class='lr-frames lr-forms-container'>\n<div id='lr-traditional-login' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>...or login with your email</h2>\n<div id='login-container' class='lr-widget-container'>\n</div>\n<div class='lr-link-box'>\n<a class='lr-raas-forgot-password'>Forgot password?</a>\n<a class='lr-register-link'>Create Account</a>\n</div>\n</div>\n<div id='lr-raas-registartion' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>...or create an account</h2>\n<div id='registration-container' class='lr-widget-container'>\n</div>\n<div class='lr-link-box'>\n<a class='lr-raas-forgot-password'>Forgot password?</a>\n<a class='lr-raas-login-link'>Login</a>\n</div>\n</div>\n<div id='lr-raas-forgotpassword' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>Forgot Password</h2>\n<p class='lr-form-login-subnote'>We'll email you an instruction on how to reset your password.</p>\n<div id='forgotpassword-container' class='lr-widget-container'>\n</div>\n<div class='lr-link-box'>\n<a class='lr-raas-login-link'>Login</a>\n<a class='lr-register-link'>Create Account</a>\n</div>\n</div>\n<div id='lr-raas-sociallogin' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>Complete your Profile</h2>\n<p class='lr-form-login-subnote'>Require to fill all mandatory fields.</p>\n<div id='sociallogin-container' class='lr-widget-container'>\n</div>\n</div>\n<div id='lr-raas-resetpassword' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>Reset your Password</h2>\n<p class='lr-form-login-subnote'>Reset your password to get back access of your account</p>\n<div id='resetpassword-container' class='lr-widget-container'>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class='lr_fade lr-loading-screen-overlay' id='loading-spinner'>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n</div>",
      EndScript: "",
      BeforeScript: "/js/default-auth-before-script.js",
      CustomJS: [],
      IsActive: true,
      MainScript: "",
      CommonScript: "/js/auth-common.js"
    },
    {
      PageType: "Profile",
      CustomCss: ["/css/hosted-auth-default.css"],
      HeadTags: [],
      FavIcon: "/dev/hosted-page/images/favicon.ico",
      HtmlBody:
        "<div class='grid lr-hostr-container lr-hostr-logged-in'>\n<div id='lr-raas-message' class='loginradius-raas-success-message'></div>\n<div class='grid lr-hostr-frame cf'>\n<div class='lr-profile-frame lr-social-login-frame lr-frames lr-sample-background-enabled cf'>\n<div class='lr-profile-image'><img alt=''></div>\n<h1 class='lr-profile-name'></h1>\n<div class='lr-profile-info'><p></p></div>\n<div class='lr-link-social-container'>\n<div class='lr-linked-social-frame' id='lr-linked-social'>\n<h5 class='lr-heading'>Linked social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"linkedAccountsTemplate\"><# if(isLinked) { #> <div class=\"lr-social-account\"><span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\"></span><span class=\"lr-social-info\"><#= Name #></span><span class=\"lr-social-unlink\"><a onclick='return window[\"loginradiusv1\"]? unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\") : LRObject.util.unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\")'>Unlink</a></span></div><# } #></script><div class='lr-not-linked-social-frame' id='lr-not-linked-social'>\n<h5 class='lr-heading'>Link more social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"notLinkedAccountsTemplate\"><# if(!isLinked) { #> <span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\" onclick='LRObject.util.openWindow(\"<#= Endpoint #>\");'></span><# } #></script></div>\n<div class='lr-menu lr-account-menu'>\n<div class='lr-menu-button'></div>\n<div class='lr-menu-list-frame'>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-edit-profile'>Edit Profile</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-change-password'>Change Password</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-account-settings'>Account Settings</a>\n<a class='lr-logout lr-menu-list' href='auth.aspx?action=logout'>Logout</a>\n</div>\n</div>\n</div>\n<div class='lr-frames lr-more-info-container'>\n<div class='lr-more-info-frame'>\n<div class='lr-more-info-heading'>\n<h2>My Profile</h2>\n<div class='lr-edit-profile lr-button outline-grey lr-show-settings' data-query='lr-edit-profile'>Edit</div>\n</div>\n<div class='lr-content-section cf' id='profile-viewer'>\n</div>\n</div>\n<script type=\"text/html\" id=\"profileViewTemplate\"><# if(typeof value !=\"undefined\" ) { #> <div class=\"lr-content-group\"><h6 class=\"lr-label\"><#= display #></h6> <div class=\"lr-data\"><#= value #></div></div><# } #></script><div class='lr-more-menu-contents'>\n<div id='lr-edit-profile' class='lr-more-menu-frame lr-edit-profile lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Edit My Profile</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='profile-editor-container'>\n</div>\n</div>\n<div id='lr-account-settings' class='lr-more-menu-frame lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Account Settings</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-account-settings-frame'>\n<h5 class='lr-setting-label'>Delete Account</h5>\n<div class='lr-action-box'>\n<a class='lr-button white button-shade' href='javascript:void(0)' onclick='deleteAccount();'>Delete my account</a>\n</div>\n</div>\n</div>\n<div id='lr-change-password' class='lr-more-menu-frame lr-field-editor lr-change-password lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Change Password</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='change-password'>\n</div>\n<div class='lr-editable-fields-frame' id='set-password'>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class='lr_fade lr-loading-screen-overlay' id='loading-spinner'>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n</div>",
      EndScript: "",
      BeforeScript: "/js/default-profile-before-script.js",
      CustomJS: [],
      IsActive: true,
      MainScript: "",
      CommonScript: "/js/profile-common.js"
    }
  ]
};
export const defaultThemes = [
  {
    templateName: "Template 1",
    thumbnail: "/assets/image/theme-legacy-one.jpg",
    isLegacy: true,
    id: "0",
    auth: {
      css: ["/css/hosted-auth-default.css"],
      html: "<div class='grid lr-hostr-container'>\n<div id='lr-raas-message' class='loginradius-raas-success-message'></div>\n<div class='grid lr-hostr-frame cf'>\n<div id='lr-social-login' class='lr-social-login-frame lr-frames lr-sample-background-enabled cf'>\n<h2 class='lr-social-login-message'>Login with your social account</h2>\n<div id='interfacecontainerdiv' class='lr-sl-shaded-brick-frame cf lr-widget-container'>\n</div>\n<script type=\"text/html\" id=\"loginradiuscustom_tmpl\"><span class=\"lr-provider-label lr-sl-shaded-brick-button lr-flat-<#=Name.toLowerCase()#>\" onclick=\" return LRObject.util.openWindow('<#= Endpoint #>'); \" title=\"Sign up with <#= Name #>\" alt=\"Sign in with <#= Name#>\"><span class=\"lr-sl-icon lr-sl-icon-<#= Name.toLowerCase()#>\"></span>Login with <#= Name#> </span> </script></div>\n<div class='lr-frames lr-forms-container'>\n<div id='lr-traditional-login' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>...or login with your email</h2>\n<div id='login-container' class='lr-widget-container'>\n</div>\n<div class='lr-link-box'>\n<a class='lr-raas-forgot-password'>Forgot password?</a>\n<a class='lr-register-link'>Create Account</a>\n</div>\n</div>\n<div id='lr-raas-registartion' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>...or create an account</h2>\n<div id='registration-container' class='lr-widget-container'>\n</div>\n<div class='lr-link-box'>\n<a class='lr-raas-forgot-password'>Forgot password?</a>\n<a class='lr-raas-login-link'>Login</a>\n</div>\n</div>\n<div id='lr-raas-forgotpassword' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>Forgot Password</h2>\n<p class='lr-form-login-subnote'>We'll email you an instruction on how to reset your password.</p>\n<div id='forgotpassword-container' class='lr-widget-container'>\n</div>\n<div class='lr-link-box'>\n<a class='lr-raas-login-link'>Login</a>\n<a class='lr-register-link'>Create Account</a>\n</div>\n</div>\n<div id='lr-raas-sociallogin' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>Complete your Profile</h2>\n<p class='lr-form-login-subnote'>Require to fill all mandatory fields.</p>\n<div id='sociallogin-container' class='lr-widget-container'>\n</div>\n</div>\n<div id='lr-raas-resetpassword' class='lr-form-frame'>\n<h2 class='lr-form-login-message'>Reset your Password</h2>\n<p class='lr-form-login-subnote'>Reset your password to get back access of your account</p>\n<div id='resetpassword-container' class='lr-widget-container'>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class='lr_fade lr-loading-screen-overlay' id='loading-spinner'>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n</div>",
      js: "/js/default-auth-before-script.js",
      custJs: [],
      commonJs: "/js/auth-common.js"
    },
    profile: {
      css: ["/css/hosted-auth-default.css"],
      html: "<div class='grid lr-hostr-container lr-hostr-logged-in'>\n<div id='lr-raas-message' class='loginradius-raas-success-message'></div>\n<div class='grid lr-hostr-frame cf'>\n<div class='lr-profile-frame lr-social-login-frame lr-frames lr-sample-background-enabled cf'>\n<div class='lr-profile-image'><img alt=''></div>\n<h1 class='lr-profile-name'></h1>\n<div class='lr-profile-info'><p></p></div>\n<div class='lr-link-social-container'>\n<div class='lr-linked-social-frame' id='lr-linked-social'>\n<h5 class='lr-heading'>Linked social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"linkedAccountsTemplate\"><# if(isLinked) { #> <div class=\"lr-social-account\"><span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\"></span><span class=\"lr-social-info\"><#= Name #></span><span class=\"lr-social-unlink\"><a onclick='return window[\"loginradiusv1\"]? unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\") : LRObject.util.unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\")'>Unlink</a></span></div><# } #></script><div class='lr-not-linked-social-frame' id='lr-not-linked-social'>\n<h5 class='lr-heading'>Link more social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"notLinkedAccountsTemplate\"><# if(!isLinked) { #> <span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\" onclick='LRObject.util.openWindow(\"<#= Endpoint #>\");'></span><# } #></script></div>\n<div class='lr-menu lr-account-menu'>\n<div class='lr-menu-button'></div>\n<div class='lr-menu-list-frame'>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-edit-profile'>Edit Profile</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-change-password'>Change Password</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-account-settings'>Account Settings</a>\n<a class='lr-logout lr-menu-list' href='auth.aspx?action=logout'>Logout</a>\n</div>\n</div>\n</div>\n<div class='lr-frames lr-more-info-container'>\n<div class='lr-more-info-frame'>\n<div class='lr-more-info-heading'>\n<h2>My Profile</h2>\n<div class='lr-edit-profile lr-button outline-grey lr-show-settings' data-query='lr-edit-profile'>Edit</div>\n</div>\n<div class='lr-content-section cf' id='profile-viewer'>\n</div>\n</div>\n<script type=\"text/html\" id=\"profileViewTemplate\"><# if(typeof value !=\"undefined\" ) { #> <div class=\"lr-content-group\"><h6 class=\"lr-label\"><#= display #></h6> <div class=\"lr-data\"><#= value #></div></div><# } #></script><div class='lr-more-menu-contents'>\n<div id='lr-edit-profile' class='lr-more-menu-frame lr-edit-profile lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Edit My Profile</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='profile-editor-container'>\n</div>\n</div>\n<div id='lr-account-settings' class='lr-more-menu-frame lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Account Settings</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-account-settings-frame'>\n<h5 class='lr-setting-label'>Delete Account</h5>\n<div class='lr-action-box'>\n<a class='lr-button white button-shade' href='javascript:void(0)' onclick='deleteAccount();'>Delete my account</a>\n</div>\n</div>\n</div>\n<div id='lr-change-password' class='lr-more-menu-frame lr-field-editor lr-change-password lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Change Password</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='change-password'>\n</div>\n<div class='lr-editable-fields-frame' id='set-password'>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class='lr_fade lr-loading-screen-overlay' id='loading-spinner'>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n</div>",
      js: "/js/default-profile-before-script.js",
      custJs: [],
      commonJs: "/js/profile-common.js"
    }
  },
  {
    templateName: "Template 2",
    thumbnail: "/assets/image/theme-default.png",
    isLegacy: false,
    id: "1",
    auth: {
      css: ["/Themes/Theme-Default/auth/css/idx-style.css"],
      html: "/Themes/Theme-Default/auth/index.html",
      js: "/Themes/Theme-Default/auth/js/idx-options.js",
      custJs: ["/Themes/Theme-Default/auth/js/idx-selfhosted.1.0.0.js"],
      commonJs: "/js/auth-common.js"
    },
    profile: {
      css: ["/Themes/Theme-Default/profile/css/profile-style.css"],
      html: "/Themes/Theme-Default/profile/index.html",
      js: "/Themes/Theme-Default/profile/js/profile-before-script.js",
      custJs: [],
      commonJs: "/js/profile-common.js"
    }
  },
  {
    templateName: "Template 3",
    thumbnail: "/assets/image/theme1.png",
    isLegacy: true,
    id: "2",
    auth: {
      css: ["/Themes/Theme-1/auth/css/hosted-auth-default.css", "/Themes/Theme-1/auth/css/jquery-ui.css"],
      html: "/Themes/Theme-1/auth/auth.html",
      js: "/Themes/Theme-1/auth/js/before-script.js?v=123",
      custJs: [],
      commonJs: "/js/auth-common.js"
    },
    profile: {
      css: ["/css/hosted-auth-default.css"],
      html: "<div class='grid lr-hostr-container lr-hostr-logged-in'>\n<div id='lr-raas-message' class='loginradius-raas-success-message'></div>\n<div class='grid lr-hostr-frame cf'>\n<div class='lr-profile-frame lr-social-login-frame lr-frames lr-sample-background-enabled cf'>\n<div class='lr-profile-image'><img alt=''></div>\n<h1 class='lr-profile-name'></h1>\n<div class='lr-profile-info'><p></p></div>\n<div class='lr-link-social-container'>\n<div class='lr-linked-social-frame' id='lr-linked-social'>\n<h5 class='lr-heading'>Linked social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"linkedAccountsTemplate\"><# if(isLinked) { #> <div class=\"lr-social-account\"><span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\"></span><span class=\"lr-social-info\"><#= Name #></span><span class=\"lr-social-unlink\"><a onclick='return window[\"loginradiusv1\"]? unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\") : LRObject.util.unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\")'>Unlink</a></span></div><# } #></script><div class='lr-not-linked-social-frame' id='lr-not-linked-social'>\n<h5 class='lr-heading'>Link more social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"notLinkedAccountsTemplate\"><# if(!isLinked) { #> <span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\" onclick='LRObject.util.openWindow(\"<#= Endpoint #>\");'></span><# } #></script></div>\n<div class='lr-menu lr-account-menu'>\n<div class='lr-menu-button'></div>\n<div class='lr-menu-list-frame'>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-edit-profile'>Edit Profile</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-change-password'>Change Password</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-account-settings'>Account Settings</a>\n<a class='lr-logout lr-menu-list' href='auth.aspx?action=logout'>Logout</a>\n</div>\n</div>\n</div>\n<div class='lr-frames lr-more-info-container'>\n<div class='lr-more-info-frame'>\n<div class='lr-more-info-heading'>\n<h2>My Profile</h2>\n<div class='lr-edit-profile lr-button outline-grey lr-show-settings' data-query='lr-edit-profile'>Edit</div>\n</div>\n<div class='lr-content-section cf' id='profile-viewer'>\n</div>\n</div>\n<script type=\"text/html\" id=\"profileViewTemplate\"><# if(typeof value !=\"undefined\" ) { #> <div class=\"lr-content-group\"><h6 class=\"lr-label\"><#= display #></h6> <div class=\"lr-data\"><#= value #></div></div><# } #></script><div class='lr-more-menu-contents'>\n<div id='lr-edit-profile' class='lr-more-menu-frame lr-edit-profile lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Edit My Profile</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='profile-editor-container'>\n</div>\n</div>\n<div id='lr-account-settings' class='lr-more-menu-frame lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Account Settings</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-account-settings-frame'>\n<h5 class='lr-setting-label'>Delete Account</h5>\n<div class='lr-action-box'>\n<a class='lr-button white button-shade' href='javascript:void(0)' onclick='deleteAccount();'>Delete my account</a>\n</div>\n</div>\n</div>\n<div id='lr-change-password' class='lr-more-menu-frame lr-field-editor lr-change-password lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Change Password</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='change-password'>\n</div>\n<div class='lr-editable-fields-frame' id='set-password'>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class='lr_fade lr-loading-screen-overlay' id='loading-spinner'>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n</div>",
      js: "/js/default-profile-before-script.js",
      custJs: [],
      commonJs: "/js/profile-common.js"
    }
  },
  {
    templateName: "Template 4",
    thumbnail: "/assets/image/theme2.png",
    isLegacy: true,
    id: "3",
    auth: {
      css: ["/Themes/Theme-2/auth/css/hosted-auth-default.css", "/Themes/Theme-2/auth/css/jquery-ui.css"],
      html: "/Themes/Theme-2/auth/auth.html",
      js: "/Themes/Theme-2/auth/js/before-script.js?v=123",
      custJs: [],
      commonJs: "/js/auth-common.js"
    },
    profile: {
      css: ["/css/hosted-auth-default.css"],
      html: "<div class='grid lr-hostr-container lr-hostr-logged-in'>\n<div id='lr-raas-message' class='loginradius-raas-success-message'></div>\n<div class='grid lr-hostr-frame cf'>\n<div class='lr-profile-frame lr-social-login-frame lr-frames lr-sample-background-enabled cf'>\n<div class='lr-profile-image'><img alt=''></div>\n<h1 class='lr-profile-name'></h1>\n<div class='lr-profile-info'><p></p></div>\n<div class='lr-link-social-container'>\n<div class='lr-linked-social-frame' id='lr-linked-social'>\n<h5 class='lr-heading'>Linked social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"linkedAccountsTemplate\"><# if(isLinked) { #> <div class=\"lr-social-account\"><span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\"></span><span class=\"lr-social-info\"><#= Name #></span><span class=\"lr-social-unlink\"><a onclick='return window[\"loginradiusv1\"]? unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\") : LRObject.util.unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\")'>Unlink</a></span></div><# } #></script><div class='lr-not-linked-social-frame' id='lr-not-linked-social'>\n<h5 class='lr-heading'>Link more social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"notLinkedAccountsTemplate\"><# if(!isLinked) { #> <span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\" onclick='LRObject.util.openWindow(\"<#= Endpoint #>\");'></span><# } #></script></div>\n<div class='lr-menu lr-account-menu'>\n<div class='lr-menu-button'></div>\n<div class='lr-menu-list-frame'>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-edit-profile'>Edit Profile</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-change-password'>Change Password</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-account-settings'>Account Settings</a>\n<a class='lr-logout lr-menu-list' href='auth.aspx?action=logout'>Logout</a>\n</div>\n</div>\n</div>\n<div class='lr-frames lr-more-info-container'>\n<div class='lr-more-info-frame'>\n<div class='lr-more-info-heading'>\n<h2>My Profile</h2>\n<div class='lr-edit-profile lr-button outline-grey lr-show-settings' data-query='lr-edit-profile'>Edit</div>\n</div>\n<div class='lr-content-section cf' id='profile-viewer'>\n</div>\n</div>\n<script type=\"text/html\" id=\"profileViewTemplate\"><# if(typeof value !=\"undefined\" ) { #> <div class=\"lr-content-group\"><h6 class=\"lr-label\"><#= display #></h6> <div class=\"lr-data\"><#= value #></div></div><# } #></script><div class='lr-more-menu-contents'>\n<div id='lr-edit-profile' class='lr-more-menu-frame lr-edit-profile lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Edit My Profile</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='profile-editor-container'>\n</div>\n</div>\n<div id='lr-account-settings' class='lr-more-menu-frame lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Account Settings</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-account-settings-frame'>\n<h5 class='lr-setting-label'>Delete Account</h5>\n<div class='lr-action-box'>\n<a class='lr-button white button-shade' href='javascript:void(0)' onclick='deleteAccount();'>Delete my account</a>\n</div>\n</div>\n</div>\n<div id='lr-change-password' class='lr-more-menu-frame lr-field-editor lr-change-password lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Change Password</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='change-password'>\n</div>\n<div class='lr-editable-fields-frame' id='set-password'>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class='lr_fade lr-loading-screen-overlay' id='loading-spinner'>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n</div>",
      js: "/js/default-profile-before-script.js",
      custJs: [],
      commonJs: "/js/profile-common.js"
    }
  },
  {
    templateName: "Template 5",
    thumbnail: "/assets/image/theme3.png",
    isLegacy: true,
    id: "4",
    auth: {
      css: ["/Themes/Theme-3/auth/css/hosted-auth-default.css", "/Themes/Theme-3/auth/css/jquery-ui.css"],
      html: "/Themes/Theme-3/auth/auth.html",
      js: "/Themes/Theme-3/auth/js/before-script.js?v=123",
      custJs: [],
      commonJs: "/js/auth-common.js"
    },
    profile: {
      css: ["/css/hosted-auth-default.css"],
      html: "<div class='grid lr-hostr-container lr-hostr-logged-in'>\n<div id='lr-raas-message' class='loginradius-raas-success-message'></div>\n<div class='grid lr-hostr-frame cf'>\n<div class='lr-profile-frame lr-social-login-frame lr-frames lr-sample-background-enabled cf'>\n<div class='lr-profile-image'><img alt=''></div>\n<h1 class='lr-profile-name'></h1>\n<div class='lr-profile-info'><p></p></div>\n<div class='lr-link-social-container'>\n<div class='lr-linked-social-frame' id='lr-linked-social'>\n<h5 class='lr-heading'>Linked social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"linkedAccountsTemplate\"><# if(isLinked) { #> <div class=\"lr-social-account\"><span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\"></span><span class=\"lr-social-info\"><#= Name #></span><span class=\"lr-social-unlink\"><a onclick='return window[\"loginradiusv1\"]? unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\") : LRObject.util.unLinkAccount(\"<#= Name.toLowerCase() #>\",\"<#= providerId #>\")'>Unlink</a></span></div><# } #></script><div class='lr-not-linked-social-frame' id='lr-not-linked-social'>\n<h5 class='lr-heading'>Link more social accounts</h5>\n</div>\n<script type=\"text/html\" id=\"notLinkedAccountsTemplate\"><# if(!isLinked) { #> <span class=\"lr-social-icon lr-flat-<#= Name.toLowerCase() #> button-shade lr-sl-icon lr-sl-icon-<#= Name.toLowerCase() #>\" onclick='LRObject.util.openWindow(\"<#= Endpoint #>\");'></span><# } #></script></div>\n<div class='lr-menu lr-account-menu'>\n<div class='lr-menu-button'></div>\n<div class='lr-menu-list-frame'>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-edit-profile'>Edit Profile</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-change-password'>Change Password</a>\n<a class='lr-settings lr-menu-list lr-show-settings' data-query='lr-account-settings'>Account Settings</a>\n<a class='lr-logout lr-menu-list' href='auth.aspx?action=logout'>Logout</a>\n</div>\n</div>\n</div>\n<div class='lr-frames lr-more-info-container'>\n<div class='lr-more-info-frame'>\n<div class='lr-more-info-heading'>\n<h2>My Profile</h2>\n<div class='lr-edit-profile lr-button outline-grey lr-show-settings' data-query='lr-edit-profile'>Edit</div>\n</div>\n<div class='lr-content-section cf' id='profile-viewer'>\n</div>\n</div>\n<script type=\"text/html\" id=\"profileViewTemplate\"><# if(typeof value !=\"undefined\" ) { #> <div class=\"lr-content-group\"><h6 class=\"lr-label\"><#= display #></h6> <div class=\"lr-data\"><#= value #></div></div><# } #></script><div class='lr-more-menu-contents'>\n<div id='lr-edit-profile' class='lr-more-menu-frame lr-edit-profile lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Edit My Profile</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='profile-editor-container'>\n</div>\n</div>\n<div id='lr-account-settings' class='lr-more-menu-frame lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Account Settings</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-account-settings-frame'>\n<h5 class='lr-setting-label'>Delete Account</h5>\n<div class='lr-action-box'>\n<a class='lr-button white button-shade' href='javascript:void(0)' onclick='deleteAccount();'>Delete my account</a>\n</div>\n</div>\n</div>\n<div id='lr-change-password' class='lr-more-menu-frame lr-field-editor lr-change-password lr-account-settings'>\n<div class='lr-more-info-heading'>\n<h2>Change Password</h2>\n<a id='lr-close' class='lr-close'>&times;</a>\n</div>\n<div class='lr-editable-fields-frame' id='change-password'>\n</div>\n<div class='lr-editable-fields-frame' id='set-password'>\n</div>\n</div>\n</div>\n</div>\n</div>\n</div>\n<div class='lr_fade lr-loading-screen-overlay' id='loading-spinner'>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n<div class='load-dot'></div>\n</div>",
      js: "/js/default-profile-before-script.js",
      custJs: [],
      commonJs: "/js/profile-common.js"
    }
  }
];

export const languageOptions = [{ value: "English", text: "English", idSuffix: "English" }];

export const languages = [
  {
    value: "en-US",
    text: "English",
    checked: false
  },
  {
    value: "es-ES",
    text: "Spanish",
    checked: false
  },
  {
    value: "fr-FR",
    text: "French",
    checked: false
  },
  {
    value: "de-DE",
    text: "German",
    checked: false
  },
  {
    value: "it-IT",
    text: "Italian",
    checked: false
  }
];

export const RepeatOTPOnCall = [
  {
    value: "1",
    text: "1",
    checked: false
  },
  {
    value: "2",
    text: "2",
    checked: false
  },
  {
    value: "3",
    text: "3",
    checked: false
  },
  {
    value: "4",
    text: "4",
    checked: false
  },
  {
    value: "5",
    text: "5",
    checked: false
  },
  {
    value: "6",
    text: "6",
    checked: false
  },
  {
    value: "7",
    text: "7",
    checked: false
  },
  {
    value: "8",
    text: "8",
    checked: false
  },
  {
    value: "9",
    text: "9",
    checked: false
  },
  {
    value: "10",
    text: "10",
    checked: false
  }
];

export const fontOptions = [
  { value: "Arial", text: "Arial", idSuffix: "Arial" },
  { value: "Barlow", text: "Barlow", idSuffix: "Barlow" },
  { value: "Helvetica", text: "Helvetica", idSuffix: "Helvetica" },
  {
    value: "TimesNewRoman",
    text: "TimesNewRoman",
    idSuffix: "TimesNewRoman"
  }
];

export const brandFontOptions = [
  { value: '"Arial", "Helvetica", sans-serif', label: "Arial" },
  { value: '"Helvetica", "Arial", sans-serif', label: "Helvetica" },
  { value: '"Times New Roman", "Times", serif', label: "Times New Roman" },
  { value: '"Courier New", "Courier", monospace', label: "Courier New" },
  { value: '"Verdana", "Geneva", sans-serif', label: "Verdana" },
  { value: '"Georgia", "Times New Roman", serif', label: "Georgia" },
  { value: '"Palatino", "Palatino Linotype", "Book Antiqua", serif', label: "Palatino" },
  { value: '"Garamond", "Baskerville", "Times New Roman", serif', label: "Garamond" },
  { value: '"Bookman", "Bookman Old Style", serif', label: "Bookman" },
  { value: '"Trebuchet MS", "Lucida Grande", "Lucida Sans Unicode", sans-serif', label: "Trebuchet MS" },
  { value: '"Impact", "Charcoal", sans-serif', label: "Impact" },
  { value: '"Comic Sans MS", "Comic Sans", cursive', label: "Comic Sans MS" },
  { value: '"Tahoma", "Geneva", sans-serif', label: "Tahoma" },
  { value: '"Lucida Console", "Courier New", monospace', label: "Lucida Console" },
  { value: '"Lucida Sans Unicode", "Lucida Grande", sans-serif', label: "Lucida Sans Unicode" },
  { value: '"Segoe UI", "Tahoma", "Geneva", sans-serif', label: "Segoe UI" },

  // Generic fallback groups
  { value: "sans-serif", label: "Sans-Serif" },
  { value: "serif", label: "Serif" },
  { value: "monospace", label: "Monospace" },

  // Popular Google Fonts (requires dynamic loading, e.g., via <link>)
  { value: '"Roboto", sans-serif', label: "Roboto" },
  { value: '"Open Sans", sans-serif', label: "Open Sans" },
  { value: '"Lato", sans-serif', label: "Lato" },
  { value: '"Montserrat", sans-serif', label: "Montserrat" },
  { value: '"Poppins", sans-serif', label: "Poppins" },
  { value: '"Inter", sans-serif', label: "Inter" },
  { value: '"Oswald", sans-serif', label: "Oswald" },
  { value: '"Raleway", sans-serif', label: "Raleway" },
  { value: '"Playfair Display", serif', label: "Playfair Display" },
  { value: '"Merriweather", serif', label: "Merriweather" },
  { value: '"Source Sans Pro", sans-serif', label: "Source Sans Pro" },
  { value: '"Nunito", sans-serif', label: "Nunito" },
  { value: '"Fira Sans", sans-serif', label: "Fira Sans" },
  { value: '"Inconsolata", monospace', label: "Inconsolata" },
  { value: '"Space Mono", monospace', label: "Space Mono" }
];

export const ProfileKey = {
  Password: "********************",
  LastPasswordChangeDate: "2018-03-05T22:13:36.48263Z",
  PasswordExpirationDate: "2028-02-07T19:02:55.803Z",
  LastPasswordChangeToken: "1542daac-4df0-4270-b5b5-5d7922492d7e",
  EmailVerified: false,
  IsActive: true,
  IsDeleted: false,
  Uid: "ffa5884ec3a943db8b5484f0d18e2fde",
  CustomFields: {
    CustomField1: "Custom data value 1 ",
    CustomField2: "Custom data value 2"
  },
  IsEmailSubscribed: false,
  UserName: "Johndoe123",
  NoOfLogins: 7,
  PreviousUids: "61432e56***1495e89d3a100e36aeb8b",
  PhoneId: "+16045552368",
  PhoneIdVerified: false,
  ExternalUserLoginId: "Johndoe123",
  RegistrationProvider: "Email",
  IsLoginLocked: false,
  LoginLockedType: "None",
  LastLoginLocation: "Vancouver, Canada",
  RegistrationSource: "API",
  IsCustomUid: false,
  UnverifiedEmail: [
    {
      Type: "Secondary",
      Value: "abc@example.com"
    }
  ],
  IsSecurePassword: true,
  ID: "0e0d1f048d8844408315aeb100f39649",
  Provider: "Email",
  Prefix: "Dr.",
  FirstName: "John",
  MiddleName: "Doe",
  LastName: "Order",
  Suffix: "Sr.",
  FullName: "John Doe Order",
  NickName: "Johnny",
  ProfileName: "Johnny",
  BirthDate: "10-12-1985",
  Gender: "M",
  Website: "www.example.com",
  Email: [
    {
      Type: "Primary",
      Value: "example@example.com"
    }
  ],
  Country: {
    Code: "ca",
    Name: "Canada"
  },
  ThumbnailImageUrl: "https://example.com/image_thumb.png",
  ImageUrl: "https://example.com/image_full.png",
  Favicon: "https://example.com/image_fav.png",
  ProfileUrl: "https://example.com/profile",
  HomeTown: "Vancouver",
  State: "British-Columbia",
  City: "Vancouver",
  Industry: "IT",
  About: "I keep track of the latest trends",
  TimeZone: "-8",
  LocalLanguage: "en-US",
  CoverPhoto: "https://example.com/profile/cover/cover_img.png",
  TagLine: "To be or not to be, that is the question",
  Language: "en-US",
  Verified: true,
  UpdatedTime: "2018-02-06T19:02:55.803Z",
  Positions: [
    {
      Position: "astronaut",
      Summary: "An astronaut.",
      StartDate: "2008-02-07T19:02:55.803Z",
      EndDate: "2015-02-07T19:02:55.803Z",
      IsCurrent: "false",
      Location: "Houston",
      Company: {
        Name: "NASA",
        Type: "astronaut",
        Industry: "National secure"
      }
    }
  ],
  Educations: [
    {
      School: "UCL",
      year: "2010",
      type: "student",
      notes: "great",
      activities: "sports",
      degree: "master",
      fieldofstudy: "astronaut",
      StartDate: "2004-02-07T19:02:55.803Z",
      EndDate: "2005-02-07T19:02:55.803Z"
    }
  ],
  PhoneNumbers: [
    {
      PhoneType: "Mobile",
      PhoneNumber: "+16045552368"
    }
  ],
  IMAccounts: [
    {
      AccountType: "primary",
      AccountName: "Example"
    }
  ],
  Addresses: [
    {
      Type: "Primary",
      Address1: "1281 West Mall",
      Address2: "Room 121",
      City: "Edmonton",
      State: "Alberta",
      PostalCode: "546841",
      Region: "Myself",
      Country: "Canada"
    }
  ],
  MainAddress: "1281 West Mall rm 121",
  Created: "5/20/2008 12:33:35 AM +00:00",
  CreatedDate: "2018-03-05T22:13:36.2013716Z",
  ModifiedDate: "2018-03-05T22:13:36.48263Z",
  LocalCity: "Vancouver",
  ProfileCity: "Vancouver",
  LocalCountry: "Canada",
  ProfileCountry: "Canada",
  FirstLogin: false,
  IsProtected: false,
  RelationshipStatus: "Single",
  Quota: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  Quote: "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.",
  InterestedIn: ["female"],
  Interests: [
    {
      InterestedType: "Sports",
      InterestedName: "Badminton"
    }
  ],
  Religion: "Undecided",
  Political: "Undecided",
  Sports: [
    {
      Id: "23423534563463466",
      Name: "Badminton"
    }
  ],
  InspirationalPeople: [
    {
      Id: "234523234323423423432424",
      Name: "Bill Gates"
    }
  ],
  HttpsImageUrl: "https://www.example.com/profile/image.png",
  FollowersCount: 70,
  FriendsCount: 800,
  IsGeoEnabled: "false",
  TotalStatusesCount: 11,
  Associations: "Board of Canada",
  NumRecommenders: 3,
  Honors: "Valedictorian",
  Awards: [
    {
      Id: "001",
      Name: "One of Smith",
      Issuer: "Lord Smith"
    }
  ],
  Skills: [
    {
      Id: "123",
      Name: "C++"
    }
  ],
  CurrentStatus: [
    {
      Id: "328",
      Text: "Gone for help",
      Source: "examplesource",
      CreateDate: "2006-02-07T19:02:55.803Z"
    }
  ],
  Certifications: [
    {
      Id: "512",
      Name: "Engineer certification",
      Authority: "The Great Engineer Association",
      Number: "1",
      StartDate: "2006-02-07T19:02:55.803Z",
      EndDate: "2007-02-07T19:02:55.803Z"
    }
  ],
  Courses: [
    {
      Id: "888",
      Name: "Advanced Algorithm",
      Number: "1"
    }
  ],
  Volunteer: [
    {
      Id: "456",
      Role: "Teacher",
      Organization: "The Great Wall",
      Cause: "Teaching people to defend the Wall"
    }
  ],
  RecommendationsReceived: [
    {
      Id: "846",
      RecommendationType: "Primary",
      RecommendationText: "The Great Wall",
      Recommender: "King"
    }
  ],
  Languages: [
    {
      Id: "484",
      Name: "Latin",
      Proficiency: "Business"
    }
  ],
  Projects: [
    {
      Id: "789",
      Name: "Night Watcher",
      Summary: "Defend the wall",
      With: [
        {
          Id: "555",
          Name: "Meng"
        }
      ],
      StartDate: "2010-02-07T19:02:55.803Z",
      EndDate: "2011-02-07T19:02:55.803Z",
      isCurrent: "false"
    }
  ],
  Games: [
    {
      Id: "777",
      Name: "Battleship",
      Category: "Strategy",
      CreateDate: "2010-10-07T19:02:55.803Z"
    }
  ],
  Family: [
    {
      Id: "055",
      Name: "Robb Smith",
      Relationship: "Brother"
    },
    {
      Id: "056",
      Name: "Eddard Smith",
      Relationship: "Father"
    }
  ],
  TeleVisionShow: [
    {
      Id: "777",
      Name: "Getting out",
      Category: "Comedy",
      CreateDate: "2011-02-07T19:02:55.803Z"
    }
  ],
  MutualFriends: [
    {
      Id: "060",
      Name: "Robb Smith",
      FirstName: "Robb",
      LastName: "Smith",
      Birthday: "2000-08-24T12:21:41.808Z",
      Hometown: "Vancouver",
      Link: "classmate",
      Gender: "M"
    },
    {
      Id: "061",
      Name: "Sansa Smith",
      FirstName: "Sansa",
      LastName: "Smith",
      Birthday: "2000-08-24T12:21:41.808Z",
      Hometown: "Vancouver",
      Link: "classmate",
      Gender: "F"
    }
  ],
  Movies: [
    {
      Id: "788",
      Name: "Le Voyage dans la Lune",
      Category: "Sci-Fi",
      CreateDate: "2017-02-07T19:02:55.803Z"
    }
  ],
  Books: [
    {
      Id: "788",
      Name: "Macbeth",
      Category: "Theatre",
      CreateDate: "2000-01-15T19:02:55.803Z"
    }
  ],
  AgeRange: {
    Min: "15",
    Max: "20"
  },
  PublicRepository: 5,
  Hireable: false,
  RepositoryUrl: "https://api.example.com/users/johnnyd/repos",
  Age: "32",
  Patents: [
    {
      Id: "516",
      Title: "Machine that flies",
      Date: "2009-02-07T19:02:55.803Z"
    }
  ],
  FavoriteThings: [
    {
      Id: "781",
      Name: "BasketBall",
      Type: "Sports"
    }
  ],
  ProfessionalHeadline: "Always, ready",
  ProviderAccessCredential: {
    AccessToken: "**************************************",
    TokenSecret: "**************************************"
  },
  RelatedProfileViews: [
    {
      Id: "884",
      FirstName: "Jemery",
      LastName: "Fir"
    }
  ],
  KloutScore: {
    KloutId: "51656",
    Score: "52.0"
  },
  LRUserID: "user32134",
  PlacesLived: [
    {
      Name: "Allision road",
      IsPrimary: "True"
    }
  ],
  Publications: [
    {
      Id: "51656",
      Title: "ASA",
      Publisher: "Fisher",
      Authors: [
        {
          Id: "51",
          Name: "Darker"
        }
      ],
      Date: "1997-02-07T19:02:55.803Z",
      Url: "whatwebsite.com",
      Summary: "What would you do as soon as you can?"
    }
  ],
  JobBookmarks: [
    {
      IsApplied: "true",
      ApplyTimestamp: "541",
      IsSaved: "false",
      SavedTimestamp: "588",
      Job: {
        Active: "true",
        Id: "51",
        DescriptionSnippet: "Darker",
        Compony: {
          Id: "489",
          Name: "Night Watch"
        },
        Position: {
          Title: "Commander"
        },
        PostingTimestamp: "988"
      }
    }
  ],
  Suggestions: {
    CompaniestoFollow: [
      {
        Id: "568",
        Name: "Amazon"
      }
    ],
    IndustriestoFollow: [
      {
        Id: "695",
        Name: "Software"
      }
    ],
    NewssourcetoFollow: [
      {
        Id: "352",
        Name: "NewYorkFans"
      }
    ],
    PeopletoFollow: [
      {
        Id: "845",
        Name: "Anna Smith"
      }
    ]
  },
  Badges: [
    {
      BadgeId: "531",
      Name: "MVP",
      BadgeMessage: "Most Valuable Person",
      Description: "An award to triple double",
      ImageUrl: "www.imageMVP.com"
    }
  ],
  MemberUrlResources: [
    {
      Url: "www.memberurl.com",
      UrlName: "MemberURL"
    }
  ],
  TotalPrivateRepository: 0,
  Currency: "CAD",
  StarredUrl: "www.image.com",
  GistsUrl: "www.gists.com",
  PublicGists: 0,
  PrivateGists: 0,
  Subscription: {
    Name: "test",
    Space: "none",
    PrivateRepos: "testRepo1",
    Collaborators: "John"
  },
  Company: "Night Watch",
  GravatarImageUrl: "www.gravatar.com/avatar/*********************",
  ProfileImageUrls: {
    ImageUrl: "https://example.com.com/*****/picture?type=small",
    ThumbnailImageUrl: "https://example.com/*****/picture?type=square"
  },
  WebProfiles: {
    Small: "https://graph.facebook.com/*****/picture?type=small",
    Square: "https://graph.Profile.com/*****/picture?type=square",
    Large: "https://graph.facebook.com/*****/picture?type=large",
    Profile: "https://graph.facebook.com/******/picture?type=normal"
  },
  PinsCount: 2,
  BoardsCount: 3,
  LikesCount: 20,
  SignupDate: "2018-03-05T22:13:36.2013716Z",
  LastLoginDate: "0001-01-01T00:00:00",
  Identities: ["&ltArray of Identities&gt"],
  Roles: ["role1", "role2"],
  Roles_Permissions: {
    role1: ["permission1", "permission2"],
    role2: ["permission3", "permission4"]
  }
};

export const advancedFields = [
  "ID",
  "FirstName",
  "LastName",
  "MiddleName",
  "NickName",
  "EmailVerified",
  "Email",
  "Avatar",
  "BirthDate",
  "Gender",
  "ImageUrl",
  "Country",
  "UnionId",
  "City",
  "Province",
  "Language",
  "ProfileName",
  "About",
  "HomeTown",
  "ProfileUrl",
  "Website",
  "RelationshipStatus",
  "Religion",
  "Political",
  "PhoneIdVerified",
  "GravatarImageUrl",
  "Prefix",
  "Suffix",
  "Industry",
  "TimeZone",
  "MainAddress",
  "ProfileCountry",
  "Company",
  "PhoneId",
  "ThumbnailImageUrl",
  "HttpsImageUrl",
  "CustomFields",
  "Verified",
  "Created",
  "UpdatedTime",
  "PublicRepository",
  "Hireable",
  "Age",
  "ProfessionalHeadline",
  "LRUserID",
  "IsEmailSubscribed",
  "State",
  "PhoneNumbers.PhoneNumber",
  "PhoneNumbers.PhoneType",
  "Addresses.Type",
  "Addresses.PostalCode",
  "Addresses.Address1",
  "Addresses.Address2",
  "Addresses.City",
  "Addresses.State",
  "Addresses.Region",
  "Addresses.Country"
];
export const selfHostedFileName = "lr-interface-options";
export const selfHostedTemplateName = "if(typeof(options) === undefined) var options;\noptions = ";
export const defaultFavicon = "/images/favicon.ico";
export const defaultLogo = "https://apidocs.lrcontent.com/images/loginradius-logo--horizontal-full-colour-on-white_196175e99f5cec6b654.20520541.png";

export const DataExportDefaultFields = [
  "ID",
  "Uid",
  "Provider",
  "Prefix",
  "FirstName",
  "MiddleName",
  "LastName",
  "Suffix",
  "FullName",
  "NickName",
  "ProfileName",
  "BirthDate",
  "Gender",
  "Website",
  "Email",
  "ThumbnailImageUrl",
  "ImageUrl",
  "Favicon",
  "ProfileUrl",
  "HomeTown",
  "State",
  "City",
  "Country",
  "Industry",
  "About",
  "TimeZone",
  "LocalLanguage",
  "CoverPhoto",
  "TagLine",
  "Language",
  "Verified",
  "UpdatedTime",
  "MainAddress",
  "Created",
  "CreatedDate",
  "ModifiedDate",
  "LocalCity",
  "LocalCountry",
  "IsProtected",
  "RelationshipStatus",
  "Quote",
  "Religion",
  "Political",
  "HttpsImageUrl",
  "FollowersCount",
  "FriendsCount",
  "IsGeoEnabled",
  "TotalStatusesCount",
  "Associations",
  "NumRecommenders",
  "Honors",
  "PublicRepository",
  "Hireable",
  "RepositoryUrl",
  "Age",
  "TotalPrivateRepository",
  "Currency",
  "StarredUrl",
  "GistsUrl",
  "PublicGists",
  "PrivateGists",
  "Company",
  "GravatarImageUrl",
  "ProfileCountry",
  "FirstLogin",
  "ProfessionalHeadline",
  "PinsCount",
  "BoardsCount",
  "LikesCount",
  "SignupDate",
  "LastLoginDate",
  "LastPasswordChangeDate",
  "PasswordExpirationDate",
  "LastPasswordChangeToken",
  "EmailVerified",
  "IsActive",
  "IsDeleted",
  "IsEmailSubscribed",
  "UserName",
  "NoOfLogins",
  "PhoneId",
  "PhoneIdVerified",
  "ExternalUserLoginId",
  "FailedLoginAttempt",
  "DisableLogin",
  "RegistrationProvider",
  "IsLoginLocked",
  "LastLoginLocation",
  "RegistrationSource",
  "IsCustomUid",
  "SignupLog.UserAgent",
  "SignupLog.IP",
  "SignupLog.Host"
];

export const DefaultRolesForTenant = [
  "Software Engineer/Developer",
  "Senior Developer",
  "DevOps Engineer",
  "Engineering Manager",
  "Technical Lead",
  "Solutions Architect",
  "Identity Architect",
  "Security Engineer",
  "Product Manager",
  "Identity and Access Management Specialist",
  "IT Manager",
  "Director of Engineering",
  "Chief Technology Officer (CTO)",
  "Chief Information Officer (CIO)",
  "Chief Executive Officer (CEO)",
  "System Administrator",
  "Cloud Engineer",
  "Data Scientist",
  "Business Analyst",
  "Project Manager",
  "Security Analyst",
  "UX/UI Developer",
  "Quality Assurance Engineer",
  "Other"
];
export const CountryCodeMapping = [
  {
    name: "Afghanistan",
    code: "AFG"
  },
  {
    name: "Angola",
    code: "AGO"
  },
  {
    name: "Albania",
    code: "ALB"
  },
  {
    name: "United Arab Emirates",
    code: "ARE"
  },
  {
    name: "Argentina",
    code: "ARG"
  },
  {
    name: "Armenia",
    code: "ARM"
  },
  {
    name: "Antarctica",
    code: "ATA"
  },
  {
    name: "French Southern and Antarctic Lands",
    code: "ATF"
  },
  {
    name: "Australia",
    code: "AUS"
  },
  {
    name: "Austria",
    code: "AUT"
  },
  {
    name: "Azerbaijan",
    code: "AZE"
  },
  {
    name: "Burundi",
    code: "BDI"
  },
  {
    name: "Belgium",
    code: "BEL"
  },
  {
    name: "Benin",
    code: "BEN"
  },
  {
    name: "Burkina Faso",
    code: "BFA"
  },
  {
    name: "Bangladesh",
    code: "BGD"
  },
  {
    name: "Bulgaria",
    code: "BGR"
  },
  {
    name: "The Bahamas",
    code: "BHS"
  },
  {
    name: "Bosnia and Herzegovina",
    code: "BIH"
  },
  {
    name: "Belarus",
    code: "BLR"
  },
  {
    name: "Belize",
    code: "BLZ"
  },
  {
    name: "Bolivia",
    code: "BOL"
  },
  {
    name: "Brazil",
    code: "BRA"
  },
  {
    name: "Brunei",
    code: "BRN"
  },
  {
    name: "Bhutan",
    code: "BTN"
  },
  {
    name: "Botswana",
    code: "BWA"
  },
  {
    name: "Central African Republic",
    code: "CAF"
  },
  {
    name: "Canada",
    code: "CAN"
  },
  {
    name: "Switzerland",
    code: "CHE"
  },
  {
    name: "Chile",
    code: "CHL"
  },
  {
    name: "China",
    code: "CHN"
  },
  {
    name: "Ivory Coast",
    code: "CIV"
  },
  {
    name: "Cameroon",
    code: "CMR"
  },
  {
    name: "Democratic Republic of the Congo",
    code: "COD"
  },
  {
    name: "Republic of the Congo",
    code: "COG"
  },
  {
    name: "Colombia",
    code: "COL"
  },
  {
    name: "Costa Rica",
    code: "CRI"
  },
  {
    name: "Cuba",
    code: "CUB"
  },
  {
    name: "Northern Cyprus",
    code: "-99"
  },
  {
    name: "Cyprus",
    code: "CYP"
  },
  {
    name: "Czech Republic",
    code: "CZE"
  },
  {
    name: "Germany",
    code: "DEU"
  },
  {
    name: "Djibouti",
    code: "DJI"
  },
  {
    name: "Denmark",
    code: "DNK"
  },
  {
    name: "Dominican Republic",
    code: "DOM"
  },
  {
    name: "Algeria",
    code: "DZA"
  },
  {
    name: "Ecuador",
    code: "ECU"
  },
  {
    name: "Egypt",
    code: "EGY"
  },
  {
    name: "Eritrea",
    code: "ERI"
  },
  {
    name: "Spain",
    code: "ESP"
  },
  {
    name: "Estonia",
    code: "EST"
  },
  {
    name: "Ethiopia",
    code: "ETH"
  },
  {
    name: "Finland",
    code: "FIN"
  },
  {
    name: "Fiji",
    code: "FJI"
  },
  {
    name: "Falkland Islands",
    code: "FLK"
  },
  {
    name: "France",
    code: "FRA"
  },
  {
    name: "Gabon",
    code: "GAB"
  },
  {
    name: "UK",
    code: "GBR"
  },
  {
    name: "United Kingdom",
    code: "GBR"
  },
  {
    name: "Georgia",
    code: "GEO"
  },
  {
    name: "Ghana",
    code: "GHA"
  },
  {
    name: "Guinea",
    code: "GIN"
  },
  {
    name: "Gambia",
    code: "GMB"
  },
  {
    name: "Guinea Bissau",
    code: "GNB"
  },
  {
    name: "Equatorial Guinea",
    code: "GNQ"
  },
  {
    name: "Greece",
    code: "GRC"
  },
  {
    name: "Greenland",
    code: "GRL"
  },
  {
    name: "Guatemala",
    code: "GTM"
  },
  {
    name: "Guyana",
    code: "GUY"
  },
  {
    name: "Honduras",
    code: "HND"
  },
  {
    name: "Croatia",
    code: "HRV"
  },
  {
    name: "Haiti",
    code: "HTI"
  },
  {
    name: "Hungary",
    code: "HUN"
  },
  {
    name: "Indonesia",
    code: "IDN"
  },
  {
    name: "India",
    code: "IND"
  },
  {
    name: "Ireland",
    code: "IRL"
  },
  {
    name: "Iran",
    code: "IRN"
  },
  {
    name: "Iraq",
    code: "IRQ"
  },
  {
    name: "Iceland",
    code: "ISL"
  },
  {
    name: "Israel",
    code: "ISR"
  },
  {
    name: "Italy",
    code: "ITA"
  },
  {
    name: "Jamaica",
    code: "JAM"
  },
  {
    name: "Jordan",
    code: "JOR"
  },
  {
    name: "Japan",
    code: "JPN"
  },
  {
    name: "Kazakhstan",
    code: "KAZ"
  },
  {
    name: "Kenya",
    code: "KEN"
  },
  {
    name: "Kyrgyzstan",
    code: "KGZ"
  },
  {
    name: "Cambodia",
    code: "KHM"
  },
  {
    name: "Kosovo",
    code: "OSA"
  },
  {
    name: "Kuwait",
    code: "KWT"
  },
  {
    name: "Laos",
    code: "LAO"
  },
  {
    name: "Lebanon",
    code: "LBN"
  },
  {
    name: "Liberia",
    code: "LBR"
  },
  {
    name: "Libya",
    code: "LBY"
  },
  {
    name: "Sri Lanka",
    code: "LKA"
  },
  {
    name: "Lesotho",
    code: "LSO"
  },
  {
    name: "Lithuania",
    code: "LTU"
  },
  {
    name: "Luxembourg",
    code: "LUX"
  },
  {
    name: "Latvia",
    code: "LVA"
  },
  {
    name: "Morocco",
    code: "MAR"
  },
  {
    name: "Moldova",
    code: "MDA"
  },
  {
    name: "Madagascar",
    code: "MDG"
  },
  {
    name: "Mexico",
    code: "MEX"
  },
  {
    name: "Macedonia",
    code: "MKD"
  },
  {
    name: "Mali",
    code: "MLI"
  },
  {
    name: "Myanmar",
    code: "MMR"
  },
  {
    name: "Montenegro",
    code: "MNE"
  },
  {
    name: "Mongolia",
    code: "MNG"
  },
  {
    name: "Mozambique",
    code: "MOZ"
  },
  {
    name: "Mauritania",
    code: "MRT"
  },
  {
    name: "Malawi",
    code: "MWI"
  },
  {
    name: "Malaysia",
    code: "MYS"
  },
  {
    name: "Namibia",
    code: "NAM"
  },
  {
    name: "New Caledonia",
    code: "NCL"
  },
  {
    name: "Niger",
    code: "NER"
  },
  {
    name: "Nigeria",
    code: "NGA"
  },
  {
    name: "Nicaragua",
    code: "NIC"
  },
  {
    name: "Netherlands",
    code: "NLD"
  },
  {
    name: "Norway",
    code: "NOR"
  },
  {
    name: "Nepal",
    code: "NPL"
  },
  {
    name: "New Zealand",
    code: "NZL"
  },
  {
    name: "Oman",
    code: "OMN"
  },
  {
    name: "Pakistan",
    code: "PAK"
  },
  {
    name: "Panama",
    code: "PAN"
  },
  {
    name: "Peru",
    code: "PER"
  },
  {
    name: "Philippines",
    code: "PHL"
  },
  {
    name: "Papua New Guinea",
    code: "PNG"
  },
  {
    name: "Poland",
    code: "POL"
  },
  {
    name: "Puerto Rico",
    code: "PRI"
  },
  {
    name: "Portugal",
    code: "PRT"
  },
  {
    name: "Paraguay",
    code: "PRY"
  },
  {
    name: "Qatar",
    code: "QAT"
  },
  {
    name: "Romania",
    code: "ROU"
  },
  {
    name: "Russia",
    code: "RUS"
  },
  {
    name: "Rwanda",
    code: "RWA"
  },
  {
    name: "Western Sahara",
    code: "ESH"
  },
  {
    name: "Saudi Arabia",
    code: "SAU"
  },
  {
    name: "Sudan",
    code: "SDN"
  },
  {
    name: "South Sudan",
    code: "SDS"
  },
  {
    name: "Senegal",
    code: "SEN"
  },
  {
    name: "Solomon Islands",
    code: "SLB"
  },
  {
    name: "Sierra Leone",
    code: "SLE"
  },
  {
    name: "El Salvador",
    code: "SLV"
  },
  {
    name: "Somaliland",
    code: "ABV"
  },
  {
    name: "Somalia",
    code: "SOM"
  },
  {
    name: "Serbia",
    code: "SRB"
  },
  {
    name: "Suriname",
    code: "SUR"
  },
  {
    name: "Slovakia",
    code: "SVK"
  },
  {
    name: "Slovenia",
    code: "SVN"
  },
  {
    name: "Sweden",
    code: "SWE"
  },
  {
    name: "Swaziland",
    code: "SWZ"
  },
  {
    name: "Syria",
    code: "SYR"
  },
  {
    name: "Chad",
    code: "TCD"
  },
  {
    name: "Togo",
    code: "TGO"
  },
  {
    name: "Thailand",
    code: "THA"
  },
  {
    name: "Tajikistan",
    code: "TJK"
  },
  {
    name: "Turkmenistan",
    code: "TKM"
  },
  {
    name: "East Timor",
    code: "TLS"
  },
  {
    name: "Trinidad and Tobago",
    code: "TTO"
  },
  {
    name: "Tunisia",
    code: "TUN"
  },
  {
    name: "Turkey",
    code: "TUR"
  },
  {
    name: "Taiwan",
    code: "TWN"
  },
  {
    name: "Tanzania",
    code: "TZA"
  },
  {
    name: "Uganda",
    code: "UGA"
  },
  {
    name: "Ukraine",
    code: "UKR"
  },
  {
    name: "Uruguay",
    code: "URY"
  },
  {
    name: "USA",
    code: "USA"
  },
  {
    name: "United States",
    code: "USA"
  },
  {
    name: "United States of America",
    code: "USA"
  },
  {
    name: "Uzbekistan",
    code: "UZB"
  },
  {
    name: "Venezuela",
    code: "VEN"
  },
  {
    name: "Vietnam",
    code: "VNM"
  },
  {
    name: "Vanuatu",
    code: "VUT"
  },
  {
    name: "West Bank",
    code: "PSE"
  },
  {
    name: "Yemen",
    code: "YEM"
  },
  {
    name: "South Africa",
    code: "ZAF"
  },
  {
    name: "Zambia",
    code: "ZMB"
  },
  {
    name: "Zimbabwe",
    code: "ZWE"
  },
  {
    name: "Korea",
    code: "KOR"
  },
  {
    name: "South Korea",
    code: "KOR"
  },
  {
    name: "North Korea",
    code: "KOR"
  }
];

export const BLUE_PRIMARY = "#0078D4";
export const BLUE_PRIMARY_HOVER = "#106EBE";
export const BLUE_PRIMARY_ACTIVE = "#005A9E";
export const BLUE_SECONDARY = "#1699FD";
export const BLUE_BACKGROUND = "#FBFDFF";
export const BLUE_PRIMARY_LIGHT = "#EFF8FF";
export const BLUE_PRIMARY_DARK = "#073857";
export const BLUE_SECONDARY_LIGHT = "#F9FCFF";
export const GRAY_LIGHT = "#EDEDED";
export const GRAY_MEDIUM = "#D9D9D9";
export const GRAY_MEDIUM_HOVER = "#CCCCCC";
export const GRAY_MEDIUM_ACTIVE = "#B8B8B8";
export const GRAY = "#a9a9a9";
export const GRAY_BORDER = "#EDEDED";
export const GRAY_LIGHTEST = "#F8F8F8";
export const GRAY_PANEL_BACKGROUND = "#FAFAFA";
export const GRAY_DIVIDER_LIGHT = "#F0F0F0";
export const BLUE_GRADIENT = "linear-gradient(180deg, #35A3F8 -21.25%, #0078D4 100%)";
export const BLUE_GRADIENT_HOVER = "linear-gradient(180deg, #0078D4 -21.25%, #0078D4 100%)";
export const BLUE_LIGHTEST = "#E6F4FF";

export const MEDIUM_BLUE = "#bee2ff";
export const TEXT_COLOR_PRIMARY = "#1f1f1f";
export const TEXT_COLOR_SECONDARY = "#595959";
export const TEXT_COLOR_TERTIARY = "#737373";
export const TEXT_COLOR_QUARTERNARY = "#bfbfbf";
export const TEXT_COLOR_MUTED = "rgba(0, 0, 0, 0.45)";
export const WHITE = "#ffffff";
export const BLACK = "#000000";
export const BLUE_BORDER = "#E7F5FF";
export const BASE_TEXT_COLOR = "#020b13";
export const SHADOW_COLOR_SOFT = "rgba(0, 0, 0, 0.2)";

export const ERROR_COLOR = "#e51e2a";
export const ERROR_COLOR_HOVER = "#CC1A26";
export const ERROR_COLOR_ACTIVE = "#B81822";
export const ERROR_COLOR_LIGHT = "#f5222d10";
export const WARNING_COLOR = "#f1a321";
export const WARNING_COLOR_DARK = "#d48806";
export const SUCCESS_COLOR = "#2ab930";
export const GREEN_DARK = "#237804";
export const WARNING_COLOR_BACKGROUND = "#FFFBE6";
export const WARNING_COLOR_BORDER = "#FFE58F";

export const FONT_FAMILY = "Inter Tight";

export const FORM_ITEM_SPACING = 24;

export const FONT_SIZE = {
  H1: 28,
  H2: 26,
  H3: 24,
  H4: 20,
  H5: 18,
  LG: 16,
  MD: 15,
  SM: 13,
  BODY: 14
};

export const LINE_HEIGHT = {
  H1: 32,
  H2: 28,
  H3: 26,
  H4: 24,
  LG: 24,
  MD: 24,
  SM: 24,
  BODY: 24
};

export const FONT_WEIGHT = {
  REGULAR: 300,
  SEMI_BOLD: 400,
  BOLD: 500,
  EXTRA_BOLD: 600,
  BLACK: 700
};

export const WORKFLOW_CARD_COLORS = [
  { mainColor: "#FFF3F3", textColor: "#691307" },
  { mainColor: "#F3F4FF", textColor: "#070B3B" },
  { mainColor: "#F1FFF9", textColor: "#006037" }
];

// ────────────────────────────────────────────────────────────────────────────
// Security Analytics palette — used by AdvancedSecurityChart and the 7 graphs
// (LoginActivity, MFAOverview, PasswordReset, BruteForceProtection,
//  BreachedPasswordDetection, BotProtection, RestrictedDomains)
// ────────────────────────────────────────────────────────────────────────────
export const SECURITY_ANALYTICS_COLORS = {
  // Neutral text + surfaces
  TEXT_DARK: "#0f172a",
  TEXT_MUTED: "#94a3b8",
  TEXT_BODY: "#64748b",
  BORDER: "#e2e8f0",
  BORDER_LIGHT: "#f1f5f9",
  BG_WHITE: "#fff",
  BG_PANEL: "#fafafa",
  CARD_BORDER: "#EDEDED",
  CARD_TEXT: "#242424",
  SHADOW_SOFT: "rgba(0, 0, 0, 0.1)",

  // KPI status colors
  TOTAL: "#3b82f6",
  TOTAL_DARK: "#1e40af",
  TOTAL_BG: "#eff6ff",
  TOTAL_BG_ICON: "#dbeafe",

  SUCCESS: "#22c55e",
  SUCCESS_DARK: "#166534",
  SUCCESS_BG: "#f0fdf4",
  SUCCESS_BORDER: "#bbf7d0",

  FAILED: "#ef4444",
  FAILED_DARK: "#991b1b",
  FAILED_BG: "#fef2f2",
  FAILED_BORDER: "#fecaca",

  WARNING: "#f97316",
  WARNING_DARK: "#9a3412",
  WARNING_BG: "#fff7ed",

  // Card icon themes (per graph)
  ICON_LOGIN: "#3b82f6",
  ICON_LOGIN_BG: "#dbeafe",
  ICON_MFA: "#22c55e",
  ICON_MFA_BG: "#f0fdf4",
  ICON_PASSWORD_RESET: "#22c55e",
  ICON_PASSWORD_RESET_BG: "#f0fdf4",
  ICON_BRUTE_FORCE: "#8b5cf6",
  ICON_BRUTE_FORCE_BG: "#f5f3ff",
  ICON_BREACHED_PASSWORD: "#a855f7",
  ICON_BREACHED_PASSWORD_BG: "#fdf4ff",
  ICON_BOT_PROTECTION: "#6366f1",
  ICON_BOT_PROTECTION_BG: "#eff0fe",
  ICON_RESTRICTED_DOMAINS: "#ef4444",
  ICON_RESTRICTED_DOMAINS_BG: "#fef2f2",

  // Factor palette — used for per-factor lines in trend charts.
  // Ordered so adjacent indices have maximum hue contrast (per-factor success/failed
  // pairs index as i*2, i*2+1, so adjacent colors must read as visually distinct).
  FACTOR_PALETTE: [
    "#6366f1", // indigo
    "#f59e0b", // amber
    "#10b981", // emerald
    "#f97316", // orange
    "#8b5cf6", // violet
    "#ef4444", // red
    "#14b8a6", // teal
    "#ec4899", // pink
    "#3b82f6", // blue
    "#22c55e", // green
    "#a855f7", // purple
    "#eab308", // yellow
    "#06b6d4", // cyan
    "#d946ef", // fuchsia
    "#0ea5e9", // sky
    "#84cc16" // lime
  ] as string[],

  // Failed-reasons bar/area colors
  REASON_PALETTE: ["#ef4444", "#f97316", "#eab308", "#3b82f6", "#8b5cf6", "#22c55e", "#14b8a6"] as string[],

  // Brute force series
  SERIES_BRUTE_FORCE: {
    SECURITY_ANSWER_INVALID: "#ef4444",
    LOGIN_IS_LOCKED_FOR_RECAPTCHA: "#f97316",
    LOGIN_IS_LOCKED_FOR_SECURITY_QUESTION: "#eab308",
    USER_ID_LOCKED: "#8b5cf6",
    LOGIN_IS_LOCKED_FOR_MFA: "#3b82f6"
  },

  // Bot protection series
  SERIES_BOT: {
    TRIGGERED: "#3b82f6",
    SUCCESSFUL: "#22c55e",
    FAILED: "#ef4444",
    ABANDONED: "#f97316"
  },

  // Breached password series
  SERIES_BREACHED: {
    BREACHED_PASSWORD: "#ef4444",
    BREACHED_PASSWORD_LOGIN: "#f97316",
    CHANGE_BREACHED_PASSWORD: "#8b5cf6"
  },

  // Restricted domains series — codes 1056+1220 merged, code 1247 separate as Spam Domain
  SERIES_RESTRICTED: {
    RESTRICTED_DOMAIN: "#ef4444",
    SPAM_DOMAIN: "#f97316"
  },

  // Tag colors — Login Activity factor groups
  TAG_PRIMARY: { bg: "#eff6ff", border: "#bfdbfe", text: "#1e40af" },
  TAG_FEDERATED: { bg: "#f5f3ff", border: "#ddd6fe", text: "#5b21b6" },

  // Tag colors — MFA factor
  TAG_MFA: { bg: "#f0fdf4", border: "#bbf7d0", text: "#166534" },

  // Tag colors — Password Reset factor groups
  TAG_PASSWORD: { bg: "#eff6ff", border: "#bfdbfe", text: "#1e40af" },
  TAG_PIN: { bg: "#fefce8", border: "#fde68a", text: "#92400e" },
  TAG_PASSKEY: { bg: "#f5f3ff", border: "#ddd6fe", text: "#5b21b6" },
  TAG_2FA: { bg: "#fef2f2", border: "#fecaca", text: "#991b1b" },

  // Tag colors — Breached Password
  TAG_BREACH: { bg: "#fdf4ff", border: "#e9d5ff", text: "#7c3aed" },

  // Tag colors — Failed Reason (red)
  TAG_REASON: { bg: "#fef2f2", border: "#fecaca", text: "#991b1b" },

  // Tag overflow ("+N more")
  TAG_OVERFLOW: { bg: "#f1f5f9", border: "#e2e8f0", text: "#64748b" }
};

export const WorkflowNodeConfig = [
  {
    title: "Authentication Nodes",
    expanded: false,
    isChildNode: false,
    nodes: [
      { type: "auth", label: "Auth" },
      { type: "socialauth", label: "Social Auth" },
      { type: "oauthauth", label: "OAuth Auth" },
      { type: "jwtauth", label: "JWT Auth" },
      { type: "samlauth", label: "SAML Auth" },
      { type: "createuser", label: "Create User" },
      { type: "updateuser", label: "Update User" },
      { type: "deleteuser", label: "Delete User" },
      { type: "assignrole", label: "Assign Role" },
      { type: "userexists", label: "User Exists" },
      {
        type: "breachedpassword",
        label: "Breached Password",
        feature: "breached_password_enabled"
      },
      {
        type: "privacypolicystatus",
        label: "Privacy Status",
        feature: "PrivacyPolicy"
      },
      {
        type: "consentstatus",
        label: "Consent Status",
        feature: "is_consentmanagement_enabled"
      },
      {
        type: "dataquery",
        label: "Data Query"
      },
      {
        type: "updatepin",
        label: "Update Pin",
        feature: "pin_authentication"
      },
      {
        type: "verifypin",
        label: "Verify Pin",
        feature: "pin_authentication"
      },
      { type: "identitylookup", label: "Identity Lookup" },
      { type: "externalidentitylookup", label: "External Identity Lookup" },
      { type: "storecustomobject", label: "Store Custom Object" },
      {
        type: "ispasskeyexists",
        label: "Is Passkey Exists",
        feature: "passkey_enabled"
      }
    ]
  },
  {
    title: "Service Nodes",
    expanded: false,
    isChildNode: false,
    nodes: [
      { type: "webpage", label: "Webpage" },
      { type: "message", label: "Message" },
      { type: "hassession", label: "Has Session" },
      {
        type: "haspinsession",
        label: "Has Pin Session",
        feature: "pin_authentication"
      },
      { type: "getcustomcookie", label: "Get Custom Cookie" },
      { type: "setcustomcookie", label: "Set Custom Cookie" },
      { type: "getsessiondata", label: "Get Session Data" },
      { type: "setsessiondata", label: "Set Session Data" },
      { type: "sendemail", label: "Send Email" },
      { type: "sendsuspendedemail", label: "Send Suspended Email" },
      { type: "sendsms", label: "Send SMS" },
      { type: "verifyotp", label: "Verify Email/SMS OTP" },
      {
        type: "verifypasskey",
        label: "Verify Passkey",
        feature: "passkey_enabled"
      },
      {
        type: "verifyauthenticatortotp",
        label: "Verify Authenticator",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsAuthenticatorEnabled"
      },
      {
        type: "verifysecurityquestion",
        label: "Verify Security Question",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsSecurityQuestionAsMFAEnabled"
      },
      {
        type: "verifybackupcode",
        label: "Verify Backup Code",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled"
      },
      {
        type: "verifyduoauth",
        label: "Verify Duo Authentication",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsDuoAuthenticatorEnabled"
      },
      {
        type: "verifypushnotification",
        label: "Verify Push Notification",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsPushAuthenticatorEnabled"
      },
      {
        type: "sendpushnotification",
        label: "Send Push Notification",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsPushAuthenticatorEnabled"
      },
      {
        type: "configurepushnotification",
        label: "Configure Push Notification",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsPushAuthenticatorEnabled"
      }
    ]
  },
  {
    title: "Auth Security Nodes",
    expanded: false,
    isChildNode: false,
    nodes: [
      { type: "accountactive", label: "Account Active" },
      { type: "suspendaccount", label: "Suspend Account" },
      { type: "lockaccount", label: "Lock Account" },
      { type: "unlockaccount", label: "Unlock Account" },
      { type: "forcelogout", label: "Force Logout" },
      { type: "logout", label: "Logout" },
      {
        type: "configuremfa",
        label: "Configure MFA",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled"
      },
      {
        type: "mfastate",
        label: "MFA State",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled"
      },
      {
        type: "mfaunconfiguredstate",
        label: "MFA Unconfigured State",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled"
      },
      {
        type: "configureauthenticator",
        label: "Configure Authenticator",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsAuthenticatorEnabled"
      },
      {
        type: "configuresecurityquestion",
        label: "Configure Security Question",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsSecurityQuestionAsMFAEnabled"
      },
      {
        type: "mfaupdatesecurityanswer",
        label: "Update Security Answer",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsSecurityQuestionAsMFAEnabled"
      },
      {
        type: "mfaupdatephone",
        label: "MFA Update Phone",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled"
      },
      {
        type: "mfadownloadbackupcode",
        label: "Download Backup Code",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled"
      },
      {
        type: "mfaresetauthenticator",
        label: "Reset Authenticator",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsAuthenticatorEnabled"
      },
      { type: "rba", label: "RBA" },
      {
        type: "adaptiverba",
        label: "Adaptive RBA",
        feature: "enable_adaptive_rba"
      }
    ]
  },
  {
    title: "Page Nodes",
    expanded: false,
    isChildNode: true,
    nodes: [
      { type: "identity", label: "Identity" },
      { type: "email", label: "Email" },
      { type: "password", label: "Password" },
      { type: "phone", label: "Phone" },
      { type: "username", label: "UserName" },
      { type: "form", label: "Form" },
      { type: "otpinput", label: "OTP Input" },
      {
        type: "pininput",
        label: "Pin Input",
        feature: "pin_authentication"
      },
      { type: "rememberme", label: "Remember Me" },
      {
        type: "privacypolicyprompt",
        label: "Privacy Prompt",
        feature: "PrivacyPolicy"
      },
      {
        type: "consentprompt",
        label: "Consent Prompt",
        feature: "is_consentmanagement_enabled"
      },
      { type: "captcha", label: "Captcha" },
      { type: "choice", label: "Choice" },
      {
        type: "backupcodeinput",
        label: "Backup Code Input",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled"
      },
      {
        type: "authenticatorinput",
        label: "Authenticator Input",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsAuthenticatorEnabled"
      },
      {
        type: "securityquestioninput",
        label: "Security Question Input",
        feature: "mfa.IsSecondFactorAuthenticatorEnabled.IsSecurityQuestionAsMFAEnabled"
      },
      { type: "facebook", label: "Facebook" },
      { type: "google", label: "Google" },
      { type: "twitter", label: "X (formerly Twitter)" },
      { type: "apple", label: "Apple" },
      { type: "customobjectinput", label: "Custom Object Input" },
      { type: "inboundsaml", label: "Inbound SAML" },
      { type: "inboundoauth", label: "Inbound Oauth" },
      { type: "inboundjwt", label: "Inbound JWT" },
      {
        type: "signuppasskey",
        label: "Sign Up Passkey",
        feature: "passkey_enabled"
      },
      {
        type: "loginpasskey",
        label: "Login Passkey",
        feature: "passkey_enabled"
      },
      {
        type: "addpasskey",
        label: "Add Passkey",
        feature: "passkey_enabled"
      }
    ]
  },
  {
    title: "Helper Nodes",
    expanded: false,
    isChildNode: false,
    nodes: [
      {
        type: "webhook",
        label: "Webhook",
        feature: "is_webhook_enabled"
      },
      { type: "childworkflow", label: "Child Workflow" },
      { type: "autolookup", label: "Auto Lookup" },
      { type: "executecustomscript", label: "Scripts" },
      { type: "trulioo", label: "Trulioo" }
    ]
  }
];

export const SUPPORTED_PROVIDERS = ["email", "phone", "username", "Twitter", "Facebook", "Google", "Apple"];

export const TRANSACTIONTEMPLATETYPES = [
  "registration",
  "forgotpassword",
  "deleteaccount",
  "add_email",
  "oneclicksignin",
  "noregistrationpasswordlesslogin",
  "forgotpin",
  "breachedpassword",
  "forgetpasskey"
];

export const defaultLRStyle = {
  common: {
    favIcon: "",
    showLogo: true,
    logoUrl: `public/assets/image/logo-icon.svg`,
    brandColor: "#0078D4",
    background: "#FFFFFF",
    primaryTextColor: "#1a1a1a",
    secondaryTextColor: "#666666",
    fontFamily: '"Arial", "Helvetica", sans-serif',
    textAlignment: "center"
  },
  card: {
    backgroundColor: "#FFFFFF",
    width: 380,
    padding: {
      top: 24,
      right: 24,
      bottom: 24,
      left: 24
    },
    border: {
      width: {
        top: 1,
        right: 1,
        bottom: 1,
        left: 1
      },
      radius: {
        topLeft: 16,
        topRight: 16,
        bottomLeft: 16,
        bottomRight: 16
      },
      color: "#EDEDED"
    },
    boxShadow: "0px 6px 16px 0px rgba(0, 0, 0, 0.06), 0px 3px 6px -4px rgba(0, 0, 0, 0.1), 0px 9px 28px 8px rgba(0, 0, 0, 0.03);",
    button: {
      primaryButton: {
        borderColor: "#0078D4",
        boxShadow: "0 2px 8px rgba(0, 120, 212, 0.3)",
        color: "#0078D4",
        textColor: "#FFFFFF",
        borderRadius: 8
      },
      secondaryButton: {
        borderColor: "#0078D4",
        boxShadow: "0 1px 2px rgba(0, 0, 0, 0.05)",
        color: "#FFFFFF",
        textColor: "#0078D4",
        borderRadius: 8
      },
      link: {
        textColor: "#0078D4",
        fontWeight: 600
      }
    },
    footer: {
      textColor: "#757575",
      borderTop: "1px solid #E0E0E0",
      backgroundColor: "#F5F5F5"
    },
    input: {
      backgroundColor: "#FFFFFF",
      textColor: "#8b8b8b",
      borderColor: "#dcdfe3"
    },
    social: {
      backgroundColor: "#ffffff",
      showIconOnly: false,
      borderRadius: 8,
      boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.02), 0px 1px 6px -1px rgba(0, 0, 0, 0.02), 0px 2px 4px 0px rgba(0, 0, 0, 0.02);",
      layout: "top",
      borderColor: "#dcdfe3",
      textColor: "#374151"
    },
    header: {
      fontSize: 20,
      fontWeight: 600
    },
    subHeader: {
      fontSize: 14,
      fontWeight: 300
    }
  }
};

export const V2_BRAND_CUTOFF_DATE = import.meta.env.VITE_V2_BRAND_CUTOFF_DATE || "2026-04-01";

export const PKCE_STATE_KEY = "pkce_state";
export const PKCE_VERIFIER_KEY = "pkce_code_verifier";

export const SUCCESS_STATUSES = [200];
export const FIELD_NAME_DATE = "Date";
export const FIELD_NAME_TOTAL_USERS = "Total Users";
export const FIELD_NAME_VALUE = "value";

import type { CSSProperties } from "react";

export type PageType = "elements" | "table" | "tabs" | "multiSection" | "singleSection";

export const PAGE_TITLE_STYLE: CSSProperties = {
  fontFamily: '"Inter Display", "Inter Tight", sans-serif',
  fontWeight: 600,
  letterSpacing: "-0.01em",
  margin: 0
};

export const PAGE_STRUCTURE: Record<PageType, { titleLevel: 1 | 2 | 3 | 4 | 5; gap: number; sectionGap?: number }> = {
  elements: { titleLevel: 3, gap: 24 },
  table: { titleLevel: 3, gap: 24 },
  tabs: { titleLevel: 3, gap: 24 },
  multiSection: { titleLevel: 4, gap: 16, sectionGap: 48 },
  singleSection: { titleLevel: 3, gap: 24, sectionGap: 16 }
};
